import { CHAMPION } from './model/Champion';
import { EFFECT } from './model/Effect';
import { EFFECT_STARS_AMOUNT, EFFECT_STARS_INDEX } from './effects';
import Synergy from './model/Synergy';

function arrayRange(min, max) {
    const array = [];
    for(let i = min; i <= max; i++) {
        array.push(i);
    }
    return array;
}

function fromId(fromId, synergies) {
    return synergies.map((synergy) => ({
        ...synergy,
        fromId,
    }));
}

let toIdsCounter = 0;
function toIds(toIds, synergy) {
    const isGrouped = toIds.length > 1;
    if (isGrouped) {
        toIdsCounter++;
    }
    return toIds.map((toId) => ({
        ...(isGrouped) ? { group: `group-${ toIdsCounter }` } : {},
        ...synergy,
        toId,
    }));
}

function fromStars(minStars, maxStars, toIdList, effectId) {
    const fromStarsRange = arrayRange(minStars, maxStars);
    const synergies = [];
    fromStarsRange
        .map((fromStars) => ({
            fromStars,
            effectId,
        }))
        .forEach((synergy) => {
            synergies.push(...toIds(toIdList, synergy));
        });
    return synergies;
}

const synergies = [

    ...fromId(CHAMPION.ABOMINATION, [
        ...fromStars(2, 6, [ CHAMPION.RHINO ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.SHEHULK ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.REDHULK ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.ABOMINATIONIMMORTAL, [
        ...fromStars(5, 6, [ CHAMPION.VENOMDUCK, CHAMPION.MANTHING ], EFFECT.FAIREST_OF_THEM_ALL),
        ...fromStars(4, 6, [ CHAMPION.ABOMINATION ], EFFECT.ABOMINABLE_COMRADE),
        ...fromStars(4, 6, [ CHAMPION.REDSKULL ], EFFECT.IMMORTAL_RULERS),
        ...fromStars(4, 6, [ CHAMPION.GROOTKING ], EFFECT.IMMORTAL_KINGS),
        ...fromStars(2, 6, [ CHAMPION.HULK, CHAMPION.REDHULK, CHAMPION.HULKIMMORTAL, CHAMPION.HULKRAGNAROK ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.AEGON, [
        ...fromStars(4, 6, [ CHAMPION.PROXIMAMIDNIGHT, CHAMPION.STARLORD ], EFFECT.COMBO_BREAKERS),
        ...fromStars(2, 6, [ CHAMPION.ANGELA, CHAMPION.PROXIMAMIDNIGHT, CHAMPION.CAPTAINMARVEL ], EFFECT.WARRIORS_OF_THE_STARS),
        ...fromStars(3, 6, [ CHAMPION.SENTRY ], EFFECT.FRIENDS),
        ...fromStars(2, 6, [ CHAMPION.THECHAMPION ], EFFECT.DAVID_AND_GOLIATH),
    ]),

    ...fromId(CHAMPION.AGENTVENOM, [
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN ], EFFECT.IDOL),
        ...fromStars(3, 6, [ CHAMPION.VENOM, CHAMPION.VENOMPOOL ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANBLACK ], EFFECT.HEALTH),
        ...fromStars(4, 6, [ CHAMPION.GROOT, CHAMPION.REDHULK ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.AIRWALKER, [
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.SILVERSURFER, CHAMPION.TERRAX, CHAMPION.COSMICGHOSTRIDER ], EFFECT.HERALDS_OF_GALACTUS),
        ...fromStars(3, 6, [ CHAMPION.NOVA ], EFFECT.NOVA_CORPS_VETERANS),
        ...fromStars(4, 6, [ CHAMPION.GREENGOBLIN, CHAMPION.PHOENIX, CHAMPION.EBONYMAW ], EFFECT.THE_HIGH_GROUND),
    ]),

    ...fromId(CHAMPION.AMERICACHAVEZ, [
        ...fromStars(2, 6, [ CHAMPION.TIGRA, CHAMPION.THING, CHAMPION.IRONMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.MOJO, CHAMPION.LONGSHOT ], EFFECT.SUPER_STARS),
        ...fromStars(4, 6, [ CHAMPION.HOOD, CHAMPION.GHOSTRIDER ], EFFECT.OUT_OF_THIS_WORLD),
        ...fromStars(4, 6, [ CHAMPION.ANNIHILUS ], EFFECT.STAY_POSITIVE),
        ...fromStars(4, 6, [ CHAMPION.SHEHULK, CHAMPION.CAPTAINMARVELMOVIE ], EFFECT.KO_QUEENS),
    ]),

    ...fromId(CHAMPION.ANGELA, [
        ...fromStars(2, 6, [ CHAMPION.ROCKET, CHAMPION.STARLORD ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.GAMORA, CHAMPION.GROOT ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.THOR ], EFFECT.HEALTH),
        ...fromStars(4, 6, [ CHAMPION.LOKI ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.ANNIHILUS, [
        ...fromStars(4, 6, [ CHAMPION.DARKHAWK ], EFFECT.DOUBLE_NEGATIVE),
        ...fromStars(3, 6, [ CHAMPION.HULKRAGNAROK ], EFFECT.CHALLENGER),
        ...fromStars(3, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.ANTMAN, [
        ...fromStars(2, 6, [ CHAMPION.YELLOWJACKET ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.HULK ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.APOCALYPSE, [
        ...fromStars(3, 6, [ CHAMPION.PSYLOCKEXFORCE ], EFFECT.BRINGER_OF_DEATH_I),
        ...fromStars(3, 6, [ CHAMPION.GAMBIT ], EFFECT.BRINGER_OF_DEATH_II),
        ...fromStars(4, 6, [ CHAMPION.STORMPYRAMIDX ], EFFECT.GUARDIAN_OF_THE_PYRAMID),
        ...fromStars(4, 6, [ CHAMPION.STORM ], EFFECT.IMPENDING_STORM),
        ...fromStars(4, 6, [ CHAMPION.MISTERSINISTER, CHAMPION.KANG, CHAMPION.CABLE ], EFFECT.YOUR_FATE_IS_MINE),
        ...fromStars(5, 6, [ CHAMPION.WOLVERINE ], EFFECT.BRINGER_OF_DEATH_III),
        ...fromStars(5, 6, [ CHAMPION.ARCHANGEL ], EFFECT.BRINGER_OF_DEATH_IV),
    ]),

    ...fromId(CHAMPION.ARCHANGEL, [
        ...fromStars(2, 6, [ CHAMPION.PSYLOCKEXFORCE ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.PHOENIX, CHAMPION.BEAST ], EFFECT.MUTANT_AGENDA),
        ...fromStars(4, 6, [ CHAMPION.ICEMAN, CHAMPION.COLOSSUS ], EFFECT.MUTANT_AGENDA),
        ...fromStars(4, 6, [ CHAMPION.GHOSTRIDER, CHAMPION.BLACKWIDOW ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.BEAST, [
        ...fromStars(4, 6, [ CHAMPION.SUPERIORIRONMAN, CHAMPION.BLACKPANTHER ], EFFECT.COMBO),
        ...fromStars(2, 6, [ CHAMPION.NIGHTCRAWLER, CHAMPION.COLOSSUS ], EFFECT.MUTANT_AGENDA),
        ...fromStars(3, 6, [ CHAMPION.IRONPATRIOT ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.GAMBIT ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.BISHOP, [
        ...fromStars(2, 6, [ CHAMPION.PSYLOCKEXFORCE ], EFFECT.CHRONAL_ANCHOR),
        ...fromStars(2, 6, [ CHAMPION.STORM ], EFFECT.ENERGY_CONDUIT),
        ...fromStars(3, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.DRSTRANGE, CHAMPION.ELECTRO ], EFFECT.ENERGY_CONDUIT),
    ]),

    ...fromId(CHAMPION.BLACKBOLT, [
        ...fromStars(2, 6, [ CHAMPION.KAMALAKHAN, CHAMPION.RONAN ], EFFECT.COSMIC_SUPREMACY),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.CYCLOPS ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.KANG ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.KARNAK, CHAMPION.MEDUSA ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.BLACKPANTHER, [
        ...fromStars(2, 6, [ CHAMPION.IRONFIST, CHAMPION.IRONFISTWHITE ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.STORM ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.STORM ], EFFECT.ROYALS),
        ...fromStars(3, 6, [ CHAMPION.IRONFIST, CHAMPION.IRONFISTWHITE ], EFFECT.WARRIORS),
        ...fromStars(5, 6, [ CHAMPION.KILLMONGER ], EFFECT.KINGS),
    ]),

    ...fromId(CHAMPION.BLACKPANTHERCIVILWAR, [
        ...fromStars(3, 6, [ CHAMPION.THEVISION, CHAMPION.BLACKWIDOW ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.WINTERSOLDIER, CHAMPION.KILLMONGER ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.ANTMAN ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.HAWKEYE, CHAMPION.BLACKPANTHER ], EFFECT.BLEED),
    ]),

    ...fromId(CHAMPION.BLACKWIDOW, [
        ...fromStars(2, 5, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.ARMOR),
        ...fromStars(2, 5, [ CHAMPION.WINTERSOLDIER ], EFFECT.POWER_GAIN),
        ...fromStars(3, 5, [ CHAMPION.HULK, CHAMPION.HULKBUSTER ], EFFECT.STUN_SPECIAL),
        ...fromStars(3, 5, [ CHAMPION.HAWKEYE ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.BLACKWIDOWCLAIRE, [
        ...fromStars(5, 6, [ CHAMPION.GHOSTRIDER ], EFFECT.JUDGEMENT_DAY),
        ...fromStars(4, 6, [ CHAMPION.DRSTRANGE ], EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.SPIDERS_BITE),
        ...fromStars(4, 6, [ CHAMPION.SUNSPOT, CHAMPION.HUMANTORCH, CHAMPION.MEPHISTO ], EFFECT.FIRE_AND_FORGET),
        ...fromStars(2, 6, [ CHAMPION.ELECTRO ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.BLACKWIDOWDEADLY, [
        ...fromStars(2, 6, [ CHAMPION.TASKMASTER ], EFFECT.REMEMBER_ME),
        ...fromStars(2, 6, [ CHAMPION.RONIN, CHAMPION.HAWKEYE ], EFFECT.REMEMBERING_BUDAPEST),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.IRONMAN, CHAMPION.FALCON, CHAMPION.BLACKPANTHER ], EFFECT.COVERT_EXPERTISE),
        ...fromStars(2, 6, [ CHAMPION.GAMORA, CHAMPION.PSYLOCKEXFORCE, CHAMPION.ELEKTRA ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK ], EFFECT.ITS_COMPLICATED),
        ...fromStars(3, 6, [ CHAMPION.REDGUARDIAN ], EFFECT.FAMILY_REUNION),
    ]),

    ...fromId(CHAMPION.BLADE, [
        ...fromStars(2, 5, [ CHAMPION.MEPHISTO, CHAMPION.DORMAMMU ], EFFECT.DEMON_HUNTER),
        ...fromStars(3, 5, [ CHAMPION.GHOSTRIDER ], EFFECT.SPIRIT_OF_JUSTICE),
        ...fromStars(4, 5, [ CHAMPION.SPIDERMANSTARK ], EFFECT.HEIGHTENED_SENSES),
    ]),

    ...fromId(CHAMPION.CABLE, [
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.PHOENIX ], EFFECT.HEALTH),
        ...fromStars(4, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.ROGUE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.CAPTAINAMERICA, [
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANBLACK ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.SUPERIORIRONMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.WINTERSOLDIER ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.CAPTAINAMERICAIW, [
        ...fromStars(2, 6, [ CHAMPION.VISION, CHAMPION.THEVISION, CHAMPION.IRONMAN ], EFFECT.TECH_BREAKTHROUGH),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.STORM, CHAMPION.BEAST ], EFFECT.MUTANT_EVOLUTION),
        ...fromStars(2, 6, [ CHAMPION.HAWKEYE, CHAMPION.BLACKWIDOW, CHAMPION.THORRAGNAROK ], EFFECT.SKILL_TRAINING_CAIW),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.HULKRAGNAROK, CHAMPION.HULK ], EFFECT.SCIENCE_EXPERIMENT),
        ...fromStars(2, 6, [ CHAMPION.SCARLETWITCH, CHAMPION.THORJANEFOSTER, CHAMPION.DRSTRANGE ], EFFECT.MYSTIC_CRAFT),
        ...fromStars(2, 6, [ CHAMPION.THOR, CHAMPION.CAPTAINMARVEL, CHAMPION.GAMORA ], EFFECT.COSMIC_POWER),
    ]),

    ...fromId(CHAMPION.CAPTAINAMERICAWWII, [
        ...fromStars(2, 6, [ CHAMPION.WINTERSOLDIER ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.GUILLOTINE ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.CAPTAINMARVEL, [
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.GAMORA ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.WOLVERINE ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.CAPTAINMARVELMOVIE, [
        ...fromStars(4, 6, [ CHAMPION.ROGUE ], EFFECT.STOLEN_MEMORIES),
        ...fromStars(4, 6, [ CHAMPION.NICKFURY ], EFFECT.PARTNERS_IN_SHIELD),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.MARVELOUS),
        ...fromStars(3, 6, [ CHAMPION.KAMALAKHAN ], EFFECT.FAN_CLUB),
    ]),

    ...fromId(CHAMPION.CARNAGE, [
        ...fromStars(2, 6, [ CHAMPION.VENOM ], EFFECT.SHARED_GENETIC_MEMORY),
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMAN ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANBLACK, CHAMPION.AGENTVENOM, CHAMPION.VENOMPOOL ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.CIVILWARRIOR, [
        ...fromStars(3, 6, [ CHAMPION.WINTERSOLDIER, CHAMPION.FALCON ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.GUILLOTINE ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.IRONMAN, CHAMPION.HULKBUSTER ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAIW, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.COLOSSUS, [
        ...fromStars(2, 6, [ CHAMPION.HYPERION, CHAMPION.MISTERSINISTER, CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.JUGGERNAUT ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.MAGIK ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.WOLVERINEOLDMAN, CHAMPION.WOLVERINE ], EFFECT.FASTBALL_SPECIAL),
        ...fromStars(3, 6, [ CHAMPION.JUGGERNAUT, CHAMPION.UNSTOPPABLECOLOSSUS ], EFFECT.FEEL_CYTORAKS_EMBRACE),
        ...fromStars(2, 6, [ CHAMPION.GAMBIT, CHAMPION.X23, CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE, CHAMPION.GOLDPOOL, CHAMPION.ROGUE, CHAMPION.BEAST, CHAMPION.DOMINO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE, CHAMPION.WOLVERINEOLDMAN ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.CORVUSGLAIVE, [
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE, CHAMPION.X23, CHAMPION.STORM ], EFFECT.HUNT_THE_UNCANNY),
        ...fromStars(4, 6, [ CHAMPION.PROXIMAMIDNIGHT ], EFFECT.CHALLENGE_DEFENSES),
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.THORRAGNAROK, CHAMPION.NEBULA, CHAMPION.CAPTAINAMERICA ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.COSMICGHOSTRIDER, [
        ...fromStars(3, 6, [ CHAMPION.MANTHING ], EFFECT.COSMIC_BANE_OF_EVIL),
        ...fromStars(3, 6, [ CHAMPION.NIGHTTHRASHER ], EFFECT.COSMIC_JUSTICE_ON_WHEELS),
        ...fromStars(4, 6, [ CHAMPION.SILVERSURFER, CHAMPION.AIRWALKER, CHAMPION.TERRAX ], EFFECT.HERALDS_OF_GALACTUS),
        ...fromStars(3, 6, [ CHAMPION.PUNISHER2099 ], EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY),
        ...fromStars(4, 6, [ CHAMPION.GHOSTRIDER ], EFFECT.SPIRITS_OF_VENGEANCE),
    ]),

    ...fromId(CHAMPION.CROSSBONES, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAWWII, CHAMPION.CAPTAINAMERICAIW ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.FALCON, CHAMPION.BLACKWIDOWDEADLY ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.WINTERSOLDIER, CHAMPION.BLACKWIDOW ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.MANGOG ], EFFECT.CONTEMPTUOUS_HATRED),
        ...fromStars(4, 6, [ CHAMPION.PUNISHER2099, CHAMPION.REDSKULL ], EFFECT.HYDRA_RECRUITERS),
        ...fromStars(4, 6, [ CHAMPION.HITMONKEY, CHAMPION.YONDU, CHAMPION.PLATINUMPOOL, CHAMPION.NEBULA ], EFFECT.MERCENARY_COMPETITION),
    ]),

    ...fromId(CHAMPION.CULLOBSIDIAN, [
        ...fromStars(3, 6, [ CHAMPION.PROXIMAMIDNIGHT, CHAMPION.CORVUSGLAIVE ], EFFECT.INVASIVE_FORCE),
        ...fromStars(3, 6, [ CHAMPION.EBONYMAW, CHAMPION.THANOS ], EFFECT.DISPLAY_OF_STRENGTH),
        ...fromStars(4, 6, [ CHAMPION.HULKBUSTER, CHAMPION.HULK, CHAMPION.HULKRAGNAROK ], EFFECT.HEROES_NEVER_LEARN),
        ...fromStars(2, 6, [ CHAMPION.IRONMANIW, CHAMPION.THORRAGNAROK, CHAMPION.CAPTAINAMERICAIW, CHAMPION.HEIMDALL ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.FALCON, CHAMPION.WARMACHINE, CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.CYCLOPS, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.STORM, CHAMPION.COLOSSUS ], EFFECT.MUTANT_AGENDA),
        ...fromStars(3, 6, [ CHAMPION.MAGNETO ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.CYCLOPS90S, [
        ...fromStars(3, 6, [ CHAMPION.MAGNETO ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.STORM ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.COLOSSUS, CHAMPION.WOLVERINE ], EFFECT.MUTANT_AGENDA),
        ...fromStars(4, 6, [ CHAMPION.PHOENIX ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.DAREDEVIL, [
        ...fromStars(3, 6, [ CHAMPION.SUPERIORIRONMAN ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.POWER_GAIN),
        ...fromStars(2, 6, [ CHAMPION.ELEKTRA ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.DAREDEVILNETFLIX, [
        ...fromStars(4, 6, [ CHAMPION.ELEKTRA, CHAMPION.PSYLOCKEXFORCE ], EFFECT.SECRET_OF_THE_HAND),
        ...fromStars(3, 6, [ CHAMPION.PUNISHER, CHAMPION.SPIDERGWEN ], EFFECT.FISK_DOWNFALL),
        ...fromStars(4, 6, [ CHAMPION.NIGHTCRAWLER, CHAMPION.GHOSTRIDER, CHAMPION.CAPTAINAMERICA ], EFFECT.STRENGTH_OF_MARTYRS),
        ...fromStars(3, 6, [ CHAMPION.SHEHULK, CHAMPION.DAREDEVIL, CHAMPION.RONAN ], EFFECT.RULE_OF_LAW),
        ...fromStars(2, 6, [ CHAMPION.LUKECAGE, CHAMPION.IRONFIST ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.KINGPIN, CHAMPION.MYSTERIO ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.DARKHAWK, [
        ...fromStars(2, 6, [ CHAMPION.IRONMANIW, CHAMPION.SPIDERMANSTARK ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.NIGHTTHRASHER, CHAMPION.MOONKNIGHT ], EFFECT.NIGHT_HAWKS),
        ...fromStars(3, 6, [ CHAMPION.VENOM, CHAMPION.PUNISHER, CHAMPION.GHOSTRIDER ], EFFECT.DARK_JUSTICE),
        ...fromStars(4, 6, [ CHAMPION.VULTURE, CHAMPION.FALCON, CHAMPION.HAWKEYE ], EFFECT.BIRDS_OF_PREY),
    ]),

    ...fromId(CHAMPION.DEADPOOL, [
        ...fromStars(2, 4, [ CHAMPION.PUNISHER ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 4, [ CHAMPION.RHINO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 4, [ CHAMPION.WOLVERINE, CHAMPION.WOLVERINEOLDMAN ], EFFECT.HEALTH),
        ...fromStars(4, 4, [ CHAMPION.VENOMPOOL ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.DEADPOOLXFORCE, [
        ...fromStars(2, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.MAGNETOMARVELNOW ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.DIABLO, [
        ...fromStars(3, 6, [ CHAMPION.LOKI, CHAMPION.REDSKULL, CHAMPION.KINGPIN ], EFFECT.UNENDING_AMBITION),
        ...fromStars(3, 6, [ CHAMPION.DROCTOPUS, CHAMPION.GREENGOBLIN, CHAMPION.MODOK ], EFFECT.MADCAP_EXPERIMENTALISTS),
        ...fromStars(4, 6, [ CHAMPION.SYMBIOTESUPREME, CHAMPION.DORMAMMU, CHAMPION.MANGOG ], EFFECT.TWISTED_ARCANISTS),
        ...fromStars(4, 6, [ CHAMPION.MEPHISTO, CHAMPION.JUGGERNAUT ], EFFECT.LEGION_ACCURSED),
        ...fromStars(2, 6, [ CHAMPION.DRDOOM, CHAMPION.ANNIHILUS, CHAMPION.PSYCHOMAN, CHAMPION.MOLEMAN ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.DRDOOM, [
        ...fromStars(4, 6, [ CHAMPION.ANNIHILUS, CHAMPION.DIABLO ], EFFECT.FANTASTIC_RAGE),
        ...fromStars(4, 6, [ CHAMPION.MODOK, CHAMPION.REDSKULL ], EFFECT.ENHANCED_FORCEFIELD),
        ...fromStars(4, 6, [ CHAMPION.MRFANTASTIC, CHAMPION.DROCTOPUS ], EFFECT.GENIUS_INGENUITY),
        ...fromStars(4, 6, [ CHAMPION.DRSTRANGE, CHAMPION.SYMBIOTESUPREME ], EFFECT.SORCERY_REVERSAL),
        ...fromStars(5, 6, [ CHAMPION.SILVERSURFER ], EFFECT.COSMIC_OVERLOAD),
        ...fromStars(5, 6, [ CHAMPION.MORNINGSTAR ], EFFECT.MYSTIC_TYRANTS),
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.DROCTOPUS, [
        ...fromStars(2, 6, [ CHAMPION.ELECTRO ], EFFECT.PARTICLE_PHYSICS),
        ...fromStars(3, 6, [ CHAMPION.ANTMAN ], EFFECT.BIOCHEMISTRY),
        ...fromStars(4, 6, [ CHAMPION.VULTURE ], EFFECT.ENGINEERING),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANSTARK ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.DRSTRANGE, [
        ...fromStars(3, 6, [ CHAMPION.THOR, CHAMPION.X23 ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.SCARLETWITCH ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.BLACKBOLT ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.DRVOODOO, [
        ...fromStars(3, 5, [ CHAMPION.ROGUE ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 5, [ CHAMPION.DRSTRANGE ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 5, [ CHAMPION.GUILLOTINE ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 5, [ CHAMPION.WINTERSOLDIER ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.DOMINO, [
        ...fromStars(2, 6, [ CHAMPION.DEADPOOLXFORCE ], EFFECT.XFORCE),
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL ], EFFECT.SIX_PACK),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINEOLDMAN, CHAMPION.SABRETOOTH ], EFFECT.WEAPON_X_STRIKE_TEAM),
        ...fromStars(2, 6, [ CHAMPION.MASACRE ], EFFECT.MERCS_FOR_MONEY),
        ...fromStars(3, 6, [ CHAMPION.REDHULK ], EFFECT.CODE_RED_REVELATIONS),
        ...fromStars(4, 6, [ CHAMPION.MODOK, CHAMPION.TASKMASTER ], EFFECT.BETTER_LUCK_NEXT_TIME),
        ...fromStars(2, 6, [ CHAMPION.COLOSSUS, CHAMPION.WOLVERINE ], EFFECT.POWER_GAIN),
        ...fromStars(2, 6, [ CHAMPION.CABLE ], EFFECT.COMPLICATED),
    ]),

    ...fromId(CHAMPION.DORMAMMU, [
        ...fromStars(3, 6, [ CHAMPION.HOOD ], EFFECT.INSEPARABLE),
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.DRVOODOO ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.KARLMORDO ], EFFECT.DARK_EMPOWERMENT),
    ]),

    ...fromId(CHAMPION.DRAGONMAN, [
        ...fromStars(2, 6, [ CHAMPION.ELSABLOODSTONE, CHAMPION.PUNISHER, CHAMPION.PUNISHER2099 ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.TIGRA ], EFFECT.NOT_SO_HIDDEN_DRAGON),
        ...fromStars(4, 6, [ CHAMPION.INVISIBLEWOMAN ], EFFECT.FIRST_CRUSH),
        ...fromStars(4, 6, [ CHAMPION.DIABLO ], EFFECT.FULL_METAL),
        ...fromStars(4, 6, [ CHAMPION.MRFANTASTIC ], EFFECT.STUDENT_LOANS),
    ]),

    ...fromId(CHAMPION.DRAX, [
        ...fromStars(4, 6, [ CHAMPION.RONAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.STARLORD ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.GAMORA ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.AGENTVENOM ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.EBONYMAW, [
        ...fromStars(3, 6, [ CHAMPION.PROXIMAMIDNIGHT, CHAMPION.CORVUSGLAIVE, CHAMPION.CULLOBSIDIAN ], EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER),
        ...fromStars(4, 6, [ CHAMPION.CULLOBSIDIAN ], EFFECT.CULL_OF_THE_MAW),
        ...fromStars(2, 6, [ CHAMPION.IRONMANIW, CHAMPION.DRSTRANGE, CHAMPION.HULKRAGNAROK, CHAMPION.SPIDERMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.THORRAGNAROK, CHAMPION.HEIMDALL, CHAMPION.LOKI ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.ELECTRO, [
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.RHINO ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.VENOM ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANMORALES ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.ELEKTRA, [
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.ELSABLOODSTONE, [
        ...fromStars(4, 6, [ CHAMPION.DARKHAWK ], EFFECT.HUNTING_PARTY),
        ...fromStars(4, 6, [ CHAMPION.BEAST ], EFFECT.BEAUTY_AND_THE_BEAST),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.CARNAGE, CHAMPION.DROCTOPUS, CHAMPION.SCARLETWITCH ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.EMMAFROST, [
        ...fromStars(2, 6, [ CHAMPION.SENTINEL ], EFFECT.MEMORIES_OF_GENOSHA),
        ...fromStars(2, 6, [ CHAMPION.COLOSSUS ], EFFECT.IMPENETRABLE_HIDE),
        ...fromStars(3, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S ], EFFECT.ITS_COMPLICATED_2),
        ...fromStars(4, 6, [ CHAMPION.PHOENIX ], EFFECT.PHOENIX_FORCE),
    ]),

    ...fromId(CHAMPION.FALCON, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.WARMACHINE, CHAMPION.BLACKWIDOW ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.THEVISION, CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.ANTMAN, CHAMPION.HAWKEYE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.GAMBIT, [
        ...fromStars(2, 6, [ CHAMPION.X23 ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.BEAST, CHAMPION.NIGHTCRAWLER ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.GAMORA, [
        ...fromStars(2, 6, [ CHAMPION.STARLORD, CHAMPION.STORM, CHAMPION.SHEHULK ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.AGENTVENOM, CHAMPION.DRAX, CHAMPION.GROOT, CHAMPION.NOVA ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.ANGELA, CHAMPION.GUILLOTINE ], EFFECT.HUNTRESS_OF_THE_CONTEST),
        ...fromStars(4, 6, [ CHAMPION.NEBULA ], EFFECT.SIBLING_RIVALRY),
        ...fromStars(4, 6, [ CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.MRFANTASTIC ], EFFECT.CYBERNETICS_UPGRADE_ASSAULT),
        ...fromStars(4, 6, [ CHAMPION.BEAST, CHAMPION.IRONMANIW ], EFFECT.CYBERNETICS_UPGRADE_TACTICS),
        ...fromStars(4, 6, [ CHAMPION.SILVERCENTURION, CHAMPION.GUILLOTINE2099 ], EFFECT.CYBERNETICS_UPGRADE_BLITZ),
    ]),

    ...fromId(CHAMPION.GHOST, [
        ...fromStars(2, 6, [ CHAMPION.ANTMAN ], EFFECT.FORMIDABLE_FOE),
        ...fromStars(2, 6, [ CHAMPION.WASP ], EFFECT.MICROSCOPIC_OBSERVATION),
        ...fromStars(3, 6, [ CHAMPION.HOOD ], EFFECT.THE_UNTOUCHABLES),
    ]),

    ...fromId(CHAMPION.GHOSTRIDER, [
        ...fromStars(2, 5, [ CHAMPION.X23 ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 5, [ CHAMPION.DEADPOOL, CHAMPION.ELEKTRA ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 5, [ CHAMPION.PUNISHER ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.GOLDPOOL, [
        ...fromStars(5, 5, [ CHAMPION.DEADPOOL, CHAMPION.VENOMPOOL, CHAMPION.GWENPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.TEAM_DEADPOOL_AWESOME_FORCE),
        ...fromStars(5, 5, [ CHAMPION.AGENTVENOM, CHAMPION.KARLMORDO ], EFFECT.ANNOYANCES_ASSEMBLE),
        ...fromStars(5, 5, [ CHAMPION.CARNAGE, CHAMPION.VOID, CHAMPION.GREENGOBLIN ], EFFECT.BROKEN_MINDS),
    ]),

    ...fromId(CHAMPION.GREENGOBLIN, [
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANBLACK, CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANMORALES ], EFFECT.SEETHING_HATRED),
        ...fromStars(2, 6, [ CHAMPION.IRONPATRIOT ], EFFECT.SPLIT_PERSONALITY),
        ...fromStars(4, 6, [ CHAMPION.ELECTRO ], EFFECT.ELECTRIC_SUPERCHARGE),
    ]),

    ...fromId(CHAMPION.GROOT, [
        ...fromStars(2, 6, [ CHAMPION.STARLORD ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.ROCKET ], EFFECT.INSEPARABLE),
        ...fromStars(3, 6, [ CHAMPION.DRAX ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.GAMORA ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.GUARDIAN, [
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE, CHAMPION.SABRETOOTH, CHAMPION.SQUIRRELGIRL, CHAMPION.DEADPOOL ], EFFECT.ON_GUARD_FOR_THEE),
        ...fromStars(4, 6, [ CHAMPION.SASQUATCH ], EFFECT.ALPHA_FLIGHT),
        ...fromStars(4, 6, [ CHAMPION.MOLEMAN ], EFFECT.EXCAVATORS),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.STORM, CHAMPION.COLOSSUS, CHAMPION.NIGHTCRAWLER ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.REDHULK ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.GUILLOTINE, [
        ...fromStars(2, 6, [ CHAMPION.VENOM ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICAWWII ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.MAGIK ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.BLACKPANTHER ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.GUILLOTINE2099, [
        ...fromStars(3, 6, [ CHAMPION.NEBULA, CHAMPION.SENTINEL, CHAMPION.WARLOCK, CHAMPION.DARKHAWK ], EFFECT.AI_UPRISING),
        ...fromStars(3, 6, [ CHAMPION.GUILLOTINE, CHAMPION.MORNINGSTAR ], EFFECT.OUR_SHARED_CURSE),
        ...fromStars(2, 6, [ CHAMPION.PUNISHER2099 ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.MEPHISTO ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.GWENPOOL, [
        ...fromStars(2, 6, [ CHAMPION.HOWARDTHEDUCK ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANBLACK ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.IDOL),
        ...fromStars(4, 6, [ CHAMPION.THORJANEFOSTER ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.HAVOK, [
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.MISTERSINISTER ], EFFECT.RUNS_IN_THE_FAMILY),
        ...fromStars(3, 6, [ CHAMPION.NIGHTCRAWLER, CHAMPION.WOLVERINE ], EFFECT.OLD_TEAMMATES),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.WASP ], EFFECT.UNCANNY_AVENGERS),
    ]),

    ...fromId(CHAMPION.HAWKEYE, [
        ...fromStars(2, 6, [ CHAMPION.SCARLETWITCH ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.HULK ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.HEIMDALL, [
        ...fromStars(3, 6, [ CHAMPION.MAGIK, CHAMPION.GUILLOTINE ], EFFECT.ENCHANTED_BLADES),
        ...fromStars(3, 6, [ CHAMPION.ANGELA, CHAMPION.HELA ], EFFECT.LOST_DAUGHTERS_OF_ASGARD),
        ...fromStars(3, 6, [ CHAMPION.THOR, CHAMPION.THORRAGNAROK, CHAMPION.LOKI ], EFFECT.WARRIORS_OF_ASGARD),
    ]),

    ...fromId(CHAMPION.HELA, [
        ...fromStars(4, 6, [ CHAMPION.THORRAGNAROK, CHAMPION.LOKI ], EFFECT.IMMORTAL_SOULS),
        ...fromStars(3, 6, [ CHAMPION.ANGELA ], EFFECT.QUEEN_OF_HEL),
        ...fromStars(2, 6, [ CHAMPION.DORMAMMU, CHAMPION.MEPHISTO ], EFFECT.HELL_LORDS),
    ]),

    ...fromId(CHAMPION.HERCULES, [
        ...fromStars(2, 6, [ CHAMPION.ANTMAN, CHAMPION.FALCON, CHAMPION.BLACKWIDOW, CHAMPION.WASP ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.HAWKEYE ], EFFECT.PAWN_SET_FREE),
        ...fromStars(4, 6, [ CHAMPION.THOR, CHAMPION.THORJANEFOSTER ], EFFECT.ARM_WRESTLING_CLUB),
        ...fromStars(4, 6, [ CHAMPION.HULK, CHAMPION.HULKIMMORTAL, CHAMPION.HULKRAGNAROK ], EFFECT.INCREDIBLE_SUBSTITUTE),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICAIW ], EFFECT.I_REQUIRE_THY_SHIELD),
        ...fromStars(5, 6, [ CHAMPION.BLACKPANTHER ], EFFECT.MASTERFUL_COMBAT),
    ]),

    ...fromId(CHAMPION.HITMONKEY, [
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.NOT_THE_FACE),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.SPIDER_MONKEY),
        ...fromStars(4, 6, [ CHAMPION.ROCKET, CHAMPION.SQUIRRELGIRL, CHAMPION.BEAST ], EFFECT.FURRY_FRENEMIES),
        ...fromStars(4, 6, [ CHAMPION.DAREDEVILNETFLIX, CHAMPION.HAWKEYE, CHAMPION.BLACKBOLT ], EFFECT.NO_EVIL),
        ...fromStars(2, 6, [ CHAMPION.BLACKWIDOWDEADLY, CHAMPION.ELEKTRA, CHAMPION.LUKECAGE, CHAMPION.TASKMASTER ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINEOLDMAN, CHAMPION.MASACRE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.HOWARDTHEDUCK, [
        ...fromStars(2, 6, [ CHAMPION.SHEHULK, CHAMPION.ROCKET ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.KAMALAKHAN, CHAMPION.DRAGONMAN, CHAMPION.MANTHING ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.MODOK, CHAMPION.PSYCHOMAN ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.GWENPOOL, CHAMPION.SPIDERHAM, CHAMPION.GOLDPOOL ], EFFECT.WE_AINT_NO_PUNCHLINE),
        ...fromStars(4, 6, [ CHAMPION.DAREDEVILNETFLIX, CHAMPION.DRSTRANGE, CHAMPION.LUKECAGE, CHAMPION.SPIDERMANSTEALTH ], EFFECT.NEW_YORK_BRAWLERS),
        ...fromStars(4, 6, [ CHAMPION.GAMBIT, CHAMPION.BISHOP, CHAMPION.STORMPYRAMIDX, CHAMPION.PLATINUMPOOL ], EFFECT.NOT_SO_UNCANNY),
    ]),

    ...fromId(CHAMPION.HULK, [
        ...fromStars(2, 6, [ CHAMPION.THOR ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.ABOMINATION ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.HAWKEYE ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.HULKBUSTER, [
        ...fromStars(3, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK ], EFFECT.DONT_MENTION_PUNY_BANNER),
        ...fromStars(4, 6, [ CHAMPION.ULTRON, CHAMPION.CULLOBSIDIAN, CHAMPION.EBONYMAW, CHAMPION.PROXIMAMIDNIGHT, CHAMPION.CORVUSGLAIVE ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.MRFANTASTIC, CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.ENGINEERING_EXPERTS),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN, CHAMPION.IRONMANIW, CHAMPION.SUPERIORIRONMAN ], EFFECT.HEALTH),
        ...fromStars(2, 6, [ CHAMPION.HULK, CHAMPION.YELLOWJACKET ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.YELLOWJACKET ], EFFECT.TECHNOLOGICAL_COMPETITION),
    ]),

    ...fromId(CHAMPION.HULKIMMORTAL, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.ALPHA_FLIGHT_SPACE_STATION),
        ...fromStars(3, 6, [ CHAMPION.SHEHULK, CHAMPION.ABOMINATIONIMMORTAL, CHAMPION.SASQUATCH ], EFFECT.GAMMA_MUTATES),
        ...fromStars(4, 6, [ CHAMPION.HULKBUSTER, CHAMPION.THOR, CHAMPION.CAPTAINAMERICA, CHAMPION.BLACKPANTHER ], EFFECT.EXTREME_MEASURES),
        ...fromStars(5, 6, [ CHAMPION.DORMAMMU, CHAMPION.MEPHISTO ], EFFECT.HELL_AND_BACK),
    ]),

    ...fromId(CHAMPION.HULKRAGNAROK, [
        ...fromStars(2, 6, [ CHAMPION.THORRAGNAROK ], EFFECT.TEAM_BUILDING_EXERCISE),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.LULLABY),
        ...fromStars(4, 6, [ CHAMPION.HELA ], EFFECT.OFF_LIMITS),
        ...fromStars(4, 6, [ CHAMPION.LOKI ], EFFECT.PUNY_GOD),
    ]),

    ...fromId(CHAMPION.HUMANTORCH, [
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.RAIN_OF_FIRE),
        ...fromStars(3, 6, [ CHAMPION.THING ], EFFECT.TURN_UP_THE_HEAT),
        ...fromStars(5, 6, [ CHAMPION.ICEMAN ], EFFECT.A_SONG_OF_FIRE_AND_ICE),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICAIW, CHAMPION.KILLMONGER ], EFFECT.FAMILIAR_FACES),
        ...fromStars(2, 6, [ CHAMPION.MEDUSA, CHAMPION.ROGUE ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.HYPERION, [
        ...fromStars(2, 5, [ CHAMPION.THOR ], EFFECT.ARMOR),
        ...fromStars(3, 5, [ CHAMPION.IRONMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 5, [ CHAMPION.DRSTRANGE ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.ICEMAN, [
        ...fromStars(2, 6, [ CHAMPION.HYPERION, CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.GHOSTRIDER, CHAMPION.BLACKWIDOW ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.INVISIBLEWOMAN, [
        ...fromStars(2, 6, [ CHAMPION.HUMANTORCH, CHAMPION.THING, CHAMPION.MRFANTASTIC ], EFFECT.FORCE_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.MRFANTASTIC ], EFFECT.TILL_DEATH),
        ...fromStars(4, 6, [ CHAMPION.HOOD, CHAMPION.DARKHAWK, CHAMPION.EBONYMAW, CHAMPION.MYSTERIO ], EFFECT.UNPHASED),
        ...fromStars(5, 6, [ CHAMPION.EMMAFROST, CHAMPION.OMEGARED, CHAMPION.SABRETOOTH, CHAMPION.MAGIK, CHAMPION.SENTRY ], EFFECT.ONE_WAY_OR_ANOTHER),
        ...fromStars(2, 6, [ CHAMPION.NAMOR ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.IRONFIST, [
        ...fromStars(2, 6, [ CHAMPION.BLACKPANTHER ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.LUKECAGE, CHAMPION.SHEHULK ], EFFECT.HEROES_FOR_HIRE),
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.IRONFISTWHITE, [
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE, CHAMPION.DAREDEVIL, CHAMPION.LUKECAGE ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.WARMACHINE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.IRONMAN, [
        ...fromStars(2, 6, [ CHAMPION.THOR, CHAMPION.WARMACHINE ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.ULTRON ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.THORJANEFOSTER ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.IRONMANIW, [
        ...fromStars(2, 6, [ CHAMPION.VISION, CHAMPION.THEVISION ], EFFECT.ESOTERIC_INSIGHT),
        ...fromStars(6, 6, [ CHAMPION.BLACKWIDOW, CHAMPION.PUNISHER2099, CHAMPION.SPIDERMANSTARK ], EFFECT.COVERT_INSIGHT),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN, CHAMPION.WARMACHINE, CHAMPION.HULKBUSTER, CHAMPION.SUPERIORIRONMAN, CHAMPION.IRONPATRIOT, CHAMPION.CIVILWARRIOR ], EFFECT.AI_UPGRADE),
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAWWII, CHAMPION.CAPTAINAMERICAIW ], EFFECT.FAMILIAR_INSIGHT),
        ...fromStars(4, 6, [ CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.KILLMONGER ], EFFECT.WAKANDAN_INSIGHT),
    ]),

    ...fromId(CHAMPION.IRONPATRIOT, [
        ...fromStars(2, 6, [ CHAMPION.IRONMAN ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.JABARIPANTHER, [
        ...fromStars(4, 6, [ CHAMPION.SORCERERSUPREME, CHAMPION.STORMPYRAMIDX, CHAMPION.SILVERCENTURION ], EFFECT.CHAMPIONS_OF_BATTLEWORLD),
        ...fromStars(2, 6, [ CHAMPION.TIGRA, CHAMPION.ELSABLOODSTONE ], EFFECT.HUNTRESSES),
        ...fromStars(3, 6, [ CHAMPION.APOCALYPSE, CHAMPION.JUGGERNAUT, CHAMPION.ARCHANGEL, CHAMPION.STORM ], EFFECT.PYRAMID_X),
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE, CHAMPION.KARLMORDO, CHAMPION.SCARLETWITCH, CHAMPION.DRVOODOO ], EFFECT.TEMPLE_OF_VISHANTI),
        ...fromStars(4, 6, [ CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.KILLMONGER ], EFFECT.TRIBAL_WARFARE),
    ]),

    ...fromId(CHAMPION.JOEFIXIT, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.MSMARVEL ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.JUBILEE, [
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE ], EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE),
        ...fromStars(3, 6, [ CHAMPION.DROCTOPUS, CHAMPION.FALCON, CHAMPION.HAWKEYE, CHAMPION.HITMONKEY ], EFFECT.DEAL_WITH_IT),
        ...fromStars(5, 6, [ CHAMPION.SENTINEL ], EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE),
        ...fromStars(2, 6, [ CHAMPION.GAMBIT, CHAMPION.ROGUE ], EFFECT.PETITE),
        ...fromStars(4, 6, [ CHAMPION.LONGSHOT, CHAMPION.MOJO ], EFFECT.THE_LUCKY_ONE),
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS, CHAMPION.PHOENIX ], EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN),
    ]),

    ...fromId(CHAMPION.JUGGERNAUT, [
        ...fromStars(2, 6, [ CHAMPION.COLOSSUS, CHAMPION.UNSTOPPABLECOLOSSUS ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.KANG, [
        ...fromStars(4, 6, [ CHAMPION.BLACKBOLT ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.THEVISION ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.THOR ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.KARNAK, [
        ...fromStars(2, 6, [ CHAMPION.BLACKBOLT, CHAMPION.MEDUSA ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.BEAST ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.KILLMONGER, [
        ...fromStars(3, 6, [ CHAMPION.WINTERSOLDIER ], EFFECT.ENHANCED_SOLDIERS),
        ...fromStars(3, 6, [ CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.WAKANDA_LEADERSHIP),
        ...fromStars(2, 2, [ CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.VOID ], EFFECT.FEARLESS),
    ]),

    ...fromId(CHAMPION.KITTYPRYDE, [
        ...fromStars(3, 6, [ CHAMPION.DRAGONMAN/*, CHAMPION.???*/ ], EFFECT.FIRE_AND_DRAGONS),
        ...fromStars(2, 6, [ CHAMPION.PROFESSORX, CHAMPION.NIGHTCRAWLER, CHAMPION.STORM, CHAMPION.CYCLOPS ], EFFECT.ARMOR),
        ...fromStars(5, 6, [ CHAMPION.GHOST ], EFFECT.JUST_A_PHASE),
        ...fromStars(2, 6, [ CHAMPION.COLOSSUS, CHAMPION.STARLORD ], EFFECT.POWER_GAIN),
        ...fromStars(6, 6, [ CHAMPION.WOLVERINE ], EFFECT.SHADOWY_HISTORY),
        ...fromStars(5, 6, [ CHAMPION.EMMAFROST ], EFFECT.THROUGH_THICK_AND_THIN),
        ...fromStars(4, 6, [ CHAMPION.TIGRA ], EFFECT.VICIOUS_KITTY),
        ...fromStars(4, 6, [ CHAMPION.MAGNETO ], EFFECT.WORTH_A_SHOT),
    ]),

    ...fromId(CHAMPION.GROOTKING, [
        ...fromStars(2, 6, [ CHAMPION.GROOT ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.HULK, CHAMPION.HULKIMMORTAL ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.VENOM, CHAMPION.ABOMINATION ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.MOJO, CHAMPION.MOLEMAN, CHAMPION.ABOMINATIONIMMORTAL, CHAMPION.VENOMDUCK ], EFFECT.GIANT_MONSTROSITIES),
        ...fromStars(4, 6, [ CHAMPION.CROSSBONES ], EFFECT.CONTEMPTUOUS_MALICE),
    ]),

    ...fromId(CHAMPION.KINGPIN, [
        ...fromStars(2, 6, [ CHAMPION.HOOD, CHAMPION.JOEFIXIT ], EFFECT.COMPETITION),
        ...fromStars(3, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.BANE_OF_HELLS_KITCHEN),
        ...fromStars(4, 6, [ CHAMPION.IRONFIST, CHAMPION.IRONFISTWHITE, CHAMPION.ELEKTRA, CHAMPION.LUKECAGE ], EFFECT.DEFENDERS_DESTROYER),
        ...fromStars(2, 6, [ CHAMPION.MISTERSINISTER, CHAMPION.MODOK, CHAMPION.ULTRON, CHAMPION.LOKI ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.KORG, [
        ...fromStars(3, 6, [ CHAMPION.THORRAGNAROK ], EFFECT.PIT_FIGHTERS),
        ...fromStars(3, 6, [ CHAMPION.HULKRAGNAROK ], EFFECT.GRANDMASTERS_CHAMPIONS),
        ...fromStars(4, 6, [ CHAMPION.ICEMAN ], EFFECT.ELEMENTAL_HIDE),
        ...fromStars(2, 6, [ CHAMPION.LOKI, CHAMPION.HEIMDALL ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.HELA ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.LOKI, [
        ...fromStars(2, 6, [ CHAMPION.THOR ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.HULK, CHAMPION.REDHULK, CHAMPION.THORJANEFOSTER ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.MASTERMINDS),
    ]),

    ...fromId(CHAMPION.LONGSHOT, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICAIW, CHAMPION.CAPTAINAMERICA ], EFFECT.CIVIL_WAR_STORIES),
        ...fromStars(3, 6, [ CHAMPION.ROGUE ], EFFECT.LOVE_TRIANGLES),
        ...fromStars(3, 6, [ CHAMPION.MOJO ], EFFECT.MOJOVERSE),
        ...fromStars(4, 6, [ CHAMPION.DOMINO ], EFFECT.PROBABLY_OP),
    ]),

    ...fromId(CHAMPION.LUKECAGE, [
        ...fromStars(2, 6, [ CHAMPION.IRONFIST, CHAMPION.IRONFISTWHITE ], EFFECT.HEROES_FOR_HIRE),
        ...fromStars(4, 6, [ CHAMPION.JUGGERNAUT, CHAMPION.IRONPATRIOT ], EFFECT.THUNDERBOLTS),
        ...fromStars(3, 6, [ CHAMPION.RHINO ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.DAREDEVIL ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.MODOK, [
        ...fromStars(3, 6, [ CHAMPION.DROCTOPUS ], EFFECT.MASTERMINDS),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.FALCON ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.ANGELA ], EFFECT.POWER_GAIN),
        ...fromStars(2, 6, [ CHAMPION.TASKMASTER ], EFFECT.ADVANCED_IDEA_MECHANICS),
        ...fromStars(3, 6, [ CHAMPION.GWENPOOL, CHAMPION.DEADPOOL ], EFFECT.CHAIR_LARCENY),
        ...fromStars(4, 6, [ CHAMPION.ABOMINATION ], EFFECT.CUBICLE_MATES),
        ...fromStars(5, 6, [ CHAMPION.ULTRON, CHAMPION.ULTRONCLASSIC ], EFFECT.SINGULARITY),
    ]),

    ...fromId(CHAMPION.MAGIK, [
        ...fromStars(2, 5, [ CHAMPION.COLOSSUS, CHAMPION.UNSTOPPABLECOLOSSUS ], EFFECT.HEALTH),
        ...fromStars(3, 5, [ CHAMPION.STORM ], EFFECT.ARMOR),
        ...fromStars(3, 5, [ CHAMPION.CYCLOPS, CHAMPION.GUILLOTINE ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 5, [ CHAMPION.JUGGERNAUT ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.MAGNETO, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.X23, CHAMPION.WOLVERINEOLDMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS90S, CHAMPION.PROFESSORX ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.STORM, CHAMPION.CYCLOPS, CHAMPION.APOCALYPSE ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.OMEGARED, CHAMPION.ROGUE, CHAMPION.SUNSPOT ], EFFECT.MUTANT_AGENDA),
        ...fromStars(4, 6, [ CHAMPION.JUGGERNAUT, CHAMPION.MAGIK, CHAMPION.SCARLETWITCH, CHAMPION.SABRETOOTH ], EFFECT.MY_BROTHERHOOD),
        ...fromStars(4, 6, [ CHAMPION.DRDOOM, CHAMPION.ULTRON, CHAMPION.KINGPIN, CHAMPION.GROOTKING ], EFFECT.MY_CONTEST_NOW),
        ...fromStars(4, 6, [ CHAMPION.ARCHANGEL, CHAMPION.PHOENIX, CHAMPION.EMMAFROST, CHAMPION.NIGHTTHRASHER ], EFFECT.MY_HELLFIRE_CLUB),
        ...fromStars(4, 6, [ CHAMPION.WOLVERINE, CHAMPION.MOJO, CHAMPION.GUILLOTINE2099, CHAMPION.MODOK ], EFFECT.MY_METALLIC_ANTIPATHY),
    ]),

    ...fromId(CHAMPION.MAGNETOMARVELNOW, [
        ...fromStars(2, 6, [ CHAMPION.THORJANEFOSTER, CHAMPION.WARLOCK, CHAMPION.JUGGERNAUT ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS, CHAMPION.BLACKBOLT ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.MAGIK, CHAMPION.WOLVERINE ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.X23, CHAMPION.CABLE, CHAMPION.TASKMASTER ], EFFECT.METALLIC_AFFINITY),
        ...fromStars(4, 6, [ CHAMPION.COLOSSUS, CHAMPION.GUARDIAN ], EFFECT.REDEMPTION),
        ...fromStars(4, 6, [ CHAMPION.APOCALYPSE, CHAMPION.PROFESSORX ], EFFECT.RISE_AGAINST_THE_CONTEST),
    ]),

    ...fromId(CHAMPION.MANGOG, [
        ...fromStars(5, 6, [ CHAMPION.LOKI ], EFFECT.AMBER_PRISON),
        ...fromStars(5, 6, [ CHAMPION.HULK, CHAMPION.BLACKWIDOW, CHAMPION.CAPTAINAMERICA, CHAMPION.HAWKEYE, CHAMPION.IRONMAN ], EFFECT.BANISHED),
        ...fromStars(2, 6, [ CHAMPION.ANGELA, CHAMPION.HELA, CHAMPION.LOKI ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.BISHOP, CHAMPION.HAVOK ], EFFECT.ENERGY_ABSORPTION),
        ...fromStars(5, 6, [ CHAMPION.ODIN ], EFFECT.FUELED_WITH_RAGE),
        ...fromStars(2, 6, [ CHAMPION.THOR, CHAMPION.HEIMDALL, CHAMPION.THORJANEFOSTER, CHAMPION.ODIN ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.KINGPIN, CHAMPION.HULKIMMORTAL, CHAMPION.WEAPONX ], EFFECT.RAGE_ON),
    ]),

    ...fromId(CHAMPION.MANTHING, [
        ...fromStars(3, 6, [ CHAMPION.GHOSTRIDER ], EFFECT.BANE_OF_EVIL),
        ...fromStars(4, 6, [ CHAMPION.GROOTKING ], EFFECT.MISUNDERSTOOD_MONSTERS),
        ...fromStars(4, 6, [ CHAMPION.THING ], EFFECT.THINGS),
        ...fromStars(2, 6, [ CHAMPION.SHEHULK, CHAMPION.HOWARDTHEDUCK ], EFFECT.FEARSOME_FOUR),
    ]),

    ...fromId(CHAMPION.MASACRE, [
        ...fromStars(2, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE, CHAMPION.GOLDPOOL ], EFFECT.INSPIRATION),
        ...fromStars(2, 6, [ CHAMPION.GWENPOOL, CHAMPION.VENOMPOOL ], EFFECT.GET_IN_THE_POOL),
        ...fromStars(3, 6, [ CHAMPION.DOMINO ], EFFECT.MERCS_FOR_MONEY),
        ...fromStars(4, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.SPIRITUAL_STRENGTH),
        ...fromStars(4, 6, [ CHAMPION.REDHULK ], EFFECT.PLAYING_WITH_FIRE),
    ]),

    ...fromId(CHAMPION.MEDUSA, [
        ...fromStars(2, 5, [ CHAMPION.WOLVERINE, CHAMPION.IRONMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 5, [ CHAMPION.QUAKE ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.KARNAK ], EFFECT.INHUMAN_ROYAL_FAMILY),
        ...fromStars(4, 5, [ CHAMPION.BLACKBOLT ], EFFECT.INHUMAN_ROYAL_FAMILY),
    ]),

    ...fromId(CHAMPION.MEPHISTO, [
        ...fromStars(2, 6, [ CHAMPION.DORMAMMU ], EFFECT.DEMONS),
        ...fromStars(3, 6, [ CHAMPION.GHOSTRIDER, CHAMPION.DRSTRANGE ], EFFECT.PACT_WITH_A_DEMON),
        ...fromStars(4, 6, [ CHAMPION.MORNINGSTAR ], EFFECT.SOUL_SEEKER),
    ]),

    ...fromId(CHAMPION.MRFANTASTIC, [
        ...fromStars(2, 6, [ CHAMPION.HUMANTORCH, CHAMPION.THING, CHAMPION.INVISIBLEWOMAN ], EFFECT.HERBIE),
        ...fromStars(4, 6, [ CHAMPION.HUMANTORCH, CHAMPION.THING, CHAMPION.INVISIBLEWOMAN ], EFFECT.FANTASTIC_FOUR),
        ...fromStars(3, 6, [ CHAMPION.INVISIBLEWOMAN ], EFFECT.DO_US_PART),
        ...fromStars(3, 6, [ CHAMPION.DRDOOM ], EFFECT.COLLEGE_RIVALS),
        ...fromStars(2, 6, [ CHAMPION.GROOT, CHAMPION.ANGELA, CHAMPION.MASACRE, CHAMPION.NIGHTTHRASHER ], EFFECT.SK_ASTRONOMY),
        ...fromStars(2, 6, [ CHAMPION.SENTRY, CHAMPION.SHEHULK, CHAMPION.VULTURE, CHAMPION.DROCTOPUS ], EFFECT.SK_ROBOTICS),
        ...fromStars(2, 6, [ CHAMPION.PSYLOCKEXFORCE, CHAMPION.STORM, CHAMPION.DRSTRANGE, CHAMPION.LOKI ], EFFECT.SK_GENETICS),
    ]),

    ...fromId(CHAMPION.MISTERNEGATIVE, [
        ...fromStars(5, 6, [ CHAMPION.DORMAMMU, CHAMPION.HOOD ], EFFECT.A_BEING_DARKER_THAN_I),
        ...fromStars(2, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DROCTOPUS, CHAMPION.HAWKEYE, CHAMPION.WOLVERINE, CHAMPION.PUNISHER ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.FROM_LIGHT_TO_DARK),
        ...fromStars(3, 6, [ CHAMPION.VENOM ], EFFECT.HEALING_TOUCH),
        ...fromStars(2, 6, [ CHAMPION.SPIDERGWEN, CHAMPION.SPIDERHAM, CHAMPION.SPIDERMANMORALES ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.MISTERSINISTER, [
        ...fromStars(2, 6, [ CHAMPION.CABLE ], EFFECT.GENETIC_MASTERPIECE),
        ...fromStars(2, 6, [ CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.MUTANT_DOMINION),
        ...fromStars(3, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.PHOENIX ], EFFECT.BLOOD_LINES),
        ...fromStars(4, 6, [ CHAMPION.MODOK, CHAMPION.KINGPIN, CHAMPION.ULTRON ], EFFECT.MASTERMINDS_TWO),
    ]),

    ...fromId(CHAMPION.MOJO, [
        ...fromStars(2, 6, [ CHAMPION.LONGSHOT ], EFFECT.MOJOVERSE),
        ...fromStars(3, 6, [ CHAMPION.PSYLOCKEXFORCE ], EFFECT.SMILE_FOR_THE_CAMERAS),
        ...fromStars(4, 6, [ CHAMPION.MODOK ], EFFECT.WITHOUT_A_LEG_TO_STAND_ON),
        ...fromStars(3, 6, [ CHAMPION.HULKRAGNAROK, CHAMPION.KORG ], EFFECT.CROWD_PLEASERS),
    ]),

    ...fromId(CHAMPION.MOLEMAN, [
        ...fromStars(3, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.GOOD_VIBRATIONS),
        ...fromStars(4, 6, [ CHAMPION.ABOMINATION, CHAMPION.MANTHING ], EFFECT.MONSTER_MASH),
        ...fromStars(2, 6, [ CHAMPION.DRDOOM, CHAMPION.DIABLO, CHAMPION.ANNIHILUS, CHAMPION.TERRAX ], EFFECT.FANTASTIC_FIENDS),
        ...fromStars(3, 6, [ CHAMPION.HUMANTORCH, CHAMPION.THING, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.MOONKNIGHT, [
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.DEADPOOLXFORCE, CHAMPION.DEADPOOL ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 6, [ CHAMPION.DAREDEVIL ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.IRONPATRIOT ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.KARLMORDO, [
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.THOR ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.FALCON, CHAMPION.ABOMINATION ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.MORNINGSTAR, [
        ...fromStars(2, 6, [ CHAMPION.GUILLOTINE ], EFFECT.MASTERS_OF_THE_SWORD),
        ...fromStars(3, 6, [ CHAMPION.MEPHISTO ], EFFECT.SOUL_SEEKER),
        ...fromStars(4, 6, [ CHAMPION.MAGIK, CHAMPION.ANGELA ], EFFECT.WARRIOR_QUEENS),
    ]),

    ...fromId(CHAMPION.MSMARVEL, [
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.THOR, CHAMPION.THORJANEFOSTER ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.KAMALAKHAN, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.IDOL),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANMORALES, CHAMPION.THORJANEFOSTER ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.VISION ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.MYSTERIO, [
        ...fromStars(2, 6, [ CHAMPION.NIGHTTHRASHER ], EFFECT.MINE_CAN_HOVER),
        ...fromStars(3, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.ENCROACHING_INSANITY),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANSTEALTH ], EFFECT.ENHANCED_ILLUSIONIST),
        ...fromStars(4, 6, [ CHAMPION.EMMAFROST ], EFFECT.MENTAL_IMMUNITY),
        ...fromStars(2, 6, [ CHAMPION.SPIDERGWEN, CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANBLACK, CHAMPION.SPIDERMANMORALES, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.NAMOR, [
        ...fromStars(5, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.TIDE_TO_GO),
        ...fromStars(4, 6, [ CHAMPION.KINGPIN, CHAMPION.BLACKPANTHER, CHAMPION.GROOTKING ], EFFECT.KINGS_OF_THE_WORLD),
        ...fromStars(3, 6, [ CHAMPION.BEAST, CHAMPION.DRAX, CHAMPION.HULK ], EFFECT.BEACH_BODS),
        ...fromStars(2, 6, [ CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.MAGNETO ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.INVISIBLEWOMAN ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.NEBULA, [
        ...fromStars(2, 6, [ CHAMPION.STARLORD, CHAMPION.ROCKET ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.DRAX ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.THANOS, CHAMPION.GAMORA ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.GAMORA ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.NICKFURY, [
        ...fromStars(3, 6, [ CHAMPION.DEADPOOLXFORCE, CHAMPION.DEADPOOL, CHAMPION.GOLDPOOL ], EFFECT.RESTORATION_KIT),
        ...fromStars(3, 6, [ CHAMPION.QUAKE, CHAMPION.ANTMAN ], EFFECT.STRATEGIC_SABOTAGE),
        ...fromStars(3, 6, [ CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.INCREASED_FIREPOWER),
        ...fromStars(4, 6, [ CHAMPION.MSMARVEL, CHAMPION.KAMALAKHAN, CHAMPION.CAPTAINMARVEL, CHAMPION.CAPTAINMARVELMOVIE ], EFFECT.CONTINGENCY_PLAN),
        ...fromStars(4, 6, [ CHAMPION.CIVILWARRIOR, CHAMPION.PUNISHER2099, CHAMPION.IRONMAN, CHAMPION.IRONMANIW ], EFFECT.EXTREME_CONDITIONS_KIT),
        ...fromStars(5, 6, [ CHAMPION.LOKI, CHAMPION.SCARLETWITCH ], EFFECT.POWER_KIT),
    ]),

    ...fromId(CHAMPION.NIGHTTHRASHER, [
        ...fromStars(2, 6, [ CHAMPION.PUNISHER, CHAMPION.MOONKNIGHT ], EFFECT.MIDNIGHT_PURSUIT),
        ...fromStars(4, 6, [ CHAMPION.GHOSTRIDER ], EFFECT.JUSTICE_ON_WHEELS),
        ...fromStars(3, 6, [ CHAMPION.GUILLOTINE ], EFFECT.CONTEST_TEAMMATES),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICAIW, CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.STARLORD ], EFFECT.TACTICAL_TRAINING),
    ]),

    ...fromId(CHAMPION.NIGHTCRAWLER, [
        ...fromStars(2, 6, [ CHAMPION.BEAST ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.JUGGERNAUT ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.X23 ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.NIMROD, [
        ...fromStars(2, 6, [ CHAMPION.DARKHAWK, CHAMPION.DRAGONMAN, CHAMPION.GUILLOTINE2099, CHAMPION.NEBULA, CHAMPION.SENTINEL, CHAMPION.ULTRON, CHAMPION.ULTRONCLASSIC, CHAMPION.VISION, CHAMPION.THEVISION, CHAMPION.WARLOCK ], EFFECT.WE_ARE_MANY),
        ...fromStars(3, 6, [ CHAMPION.ULTRON, CHAMPION.ULTRONCLASSIC ], EFFECT.ADVANCED_INTELLIGENCE),
        // ...fromStars(4, 6, [ CHAMPION.tbc ], EFFECT.NEW_WAVE),
        ...fromStars(4, 6, [ CHAMPION.SENTINEL/*, CHAMPION.???*/ ], EFFECT.RESISTANCE_IS_FUTILE),
        ...fromStars(3, 6, [ CHAMPION.KITTYPRYDE, CHAMPION.STORM ], EFFECT.TERMINATED),
    ]),

    ...fromId(CHAMPION.NOVA, [
        ...fromStars(4, 6, [ CHAMPION.NIGHTTHRASHER, CHAMPION.DARKHAWK ], EFFECT.NEW_WARRIOR_BLOOD),
        ...fromStars(3, 6, [ CHAMPION.ANNIHILUS ], EFFECT.TOTAL_ANNIHILATION),
        ...fromStars(3, 6, [ CHAMPION.BISHOP, CHAMPION.HAVOK ], EFFECT.MAXIMUM_OUTPUT),
        ...fromStars(2, 6, [ CHAMPION.GAMORA, CHAMPION.DRAX ], EFFECT.PHALANX_FEUD),
        ...fromStars(2, 6, [ CHAMPION.RHINO, CHAMPION.IRONFIST ], EFFECT.FULL_SPEED_AHEAD),
    ]),

    ...fromId(CHAMPION.WOLVERINEOLDMAN, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.HAWKEYE ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.HULK ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.MODOK, CHAMPION.X23 ], EFFECT.ENHANCED_ADAMANTIUM),
        ...fromStars(4, 6, [ CHAMPION.MYSTERIO ], EFFECT.NO_NOT_YOU),
    ]),

    ...fromId(CHAMPION.ODIN, [
        ...fromStars(2, 6, [ CHAMPION.MEPHISTO ], EFFECT.BATTLE_OF_REALMS),
        ...fromStars(2, 6, [ CHAMPION.REDSKULL, CHAMPION.THANOS ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.THORRAGNAROK, CHAMPION.HULKRAGNAROK, CHAMPION.THORJANEFOSTER ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.HEIMDALL ], EFFECT.OATHSWORN),
        ...fromStars(4, 6, [ CHAMPION.THOR, CHAMPION.HELA, CHAMPION.LOKI, CHAMPION.ANGELA ], EFFECT.ODINSONS_AND_ODINSDOTTIRS),
        ...fromStars(5, 6, [ CHAMPION.HELA ], EFFECT.WARMONGER),
    ]),

    ...fromId(CHAMPION.OMEGARED, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.COLOSSUS ], EFFECT.METAL_MAYHEM),
        ...fromStars(2, 6, [ CHAMPION.DEADPOOLXFORCE, CHAMPION.SABRETOOTH ], EFFECT.XASSASSINS),
        ...fromStars(3, 6, [ CHAMPION.REDHULK, CHAMPION.REDSKULL ], EFFECT.SEEING_RED),
        ...fromStars(4, 6, [ CHAMPION.MEPHISTO, CHAMPION.VOID ], EFFECT.DEADLY_PRESENCE),
    ]),

    ...fromId(CHAMPION.PENIPARKER, [
        ...fromStars(5, 6, [ CHAMPION.AIRWALKER, CHAMPION.FALCON ], EFFECT.ANGEL_ATTACK),
        ...fromStars(4, 6, [ CHAMPION.DAREDEVILNETFLIX, CHAMPION.MYSTERIO ], EFFECT.FIELD_TRIP),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANMORALES, CHAMPION.SPIDERGWEN, CHAMPION.SPIDERHAM ], EFFECT.SPIDERGEDDON),
        ...fromStars(2, 6, [ CHAMPION.MOLEMAN, CHAMPION.HOWARDTHEDUCK, CHAMPION.VENOMDUCK ], EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN, CHAMPION.SUNSPOT, CHAMPION.HITMONKEY ], EFFECT.SUIT_UP),
        ...fromStars(3, 6, [ CHAMPION.KANG ], EFFECT.TECHNICIAN),
    ]),

    ...fromId(CHAMPION.PHOENIX, [
        ...fromStars(3, 6, [ CHAMPION.STORM ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.CYCLOPS90S, CHAMPION.WOLVERINE ], EFFECT.ITS_COMPLICATED),
        ...fromStars(4, 6, [ CHAMPION.BEAST, CHAMPION.NIGHTCRAWLER, CHAMPION.GAMORA ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.PLATINUMPOOL, [
        ...fromStars(5, 5, [ CHAMPION.SCARLETWITCH ], EFFECT.CHAOTIC_ENERGY),
        ...fromStars(5, 5, [ CHAMPION.STARLORD ], EFFECT.CROSSOVER),
        ...fromStars(5, 5, [ CHAMPION.DRDOOM ], EFFECT.DEATHWISH),
        ...fromStars(5, 5, [ CHAMPION.JOEFIXIT ], EFFECT.GOODFELLA),
        ...fromStars(5, 5, [ CHAMPION.ROGUE ], EFFECT.MERC_WITH_A_MOUTH),
        ...fromStars(5, 5, [ CHAMPION.MAGIK ], EFFECT.STUCK_IN_LIMBO),
    ]),

    ...fromId(CHAMPION.PROFESSORX, [
        ...fromStars(3, 6, [ CHAMPION.WOLVERINE, CHAMPION.X23, CHAMPION.COLOSSUS ], EFFECT.DRUG_I),
        ...fromStars(3, 6, [ CHAMPION.STORM, CHAMPION.STORMPYRAMIDX, CHAMPION.EMMAFROST ], EFFECT.HABITAT),
        ...fromStars(4, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.PHOENIX ], EFFECT.DRUG_L),
        ...fromStars(4, 6, [ CHAMPION.BEAST, CHAMPION.NIGHTCRAWLER, CHAMPION.ARCHANGEL ], EFFECT.GATEWAY),
        ...fromStars(5, 6, [ CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW, CHAMPION.ICEMAN ], EFFECT.DRUG_M),
    ]),

    ...fromId(CHAMPION.PROXIMAMIDNIGHT, [
        ...fromStars(2, 6, [ CHAMPION.NEBULA ], EFFECT.UNMERCIFUL_PUNISHMENT),
        ...fromStars(3, 6, [ CHAMPION.THORRAGNAROK ], EFFECT.ASGARDIAN_HUNT),
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.SCARLETWITCH, CHAMPION.THEVISION, CHAMPION.HULKRAGNAROK ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.CORVUSGLAIVE ], EFFECT.SPECIAL_ASSIST),
    ]),

    ...fromId(CHAMPION.PSYCHOMAN, [
        ...fromStars(4, 6, [ CHAMPION.ANTMAN, CHAMPION.WASP, CHAMPION.YELLOWJACKET ], EFFECT.DINKY_SHRINKS),
        ...fromStars(2, 6, [ CHAMPION.SHEHULK, CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.MRFANTASTIC ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.INVISIBLEWOMAN ], EFFECT.MALICE),
        ...fromStars(4, 6, [ CHAMPION.MANGOG ], EFFECT.PURE_HATRED),
        ...fromStars(3, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE, CHAMPION.MANTHING ], EFFECT.THERE_GOES_THE_MULTIVERSE),
    ]),

    ...fromId(CHAMPION.PSYLOCKEXFORCE, [
        ...fromStars(2, 6, [ CHAMPION.ARCHANGEL ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.STORM ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.ROGUE ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.PUNISHER, [
        ...fromStars(2, 5, [ CHAMPION.SPIDERMAN ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.RHINO ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 5, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.PUNISHER2099, [
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.LOYAL_MINISTER),
        ...fromStars(2, 6, [ CHAMPION.PUNISHER ], EFFECT.CROSS_TRAINING),
        ...fromStars(4, 6, [ CHAMPION.THOR ], EFFECT.BELIEVER),
        ...fromStars(2, 6, [ CHAMPION.GUILLOTINE2099 ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.DRDOOM ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.PURGATORY, [
        ...fromStars(2, 6, [ CHAMPION.MEPHISTO, CHAMPION.HOOD, CHAMPION.MAGIK, CHAMPION.DORMAMMU ], EFFECT.DIMENSIONAL_BUDDIES),
        ...fromStars(3, 6, [ CHAMPION.HULKIMMORTAL ], EFFECT.MANY_AS_ONE),
        ...fromStars(3, 6, [ CHAMPION.GUILLOTINE ], EFFECT.POOR_UNFORTUNATE_SOUL),
        ...fromStars(4, 6, [ CHAMPION.HELA ], EFFECT.QUEENS_OF_SOULS),
        ...fromStars(4, 6, [ CHAMPION.MORNINGSTAR ], EFFECT.UNCHAINED),
        ...fromStars(4, 6, [ CHAMPION.SYMBIOTESUPREME, CHAMPION.VENOMDUCK ], EFFECT.WHAT_IF),
    ]),

    ...fromId(CHAMPION.QUAKE, [
        ...fromStars(2, 5, [ CHAMPION.CROSSBONES, CHAMPION.IRONPATRIOT ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 5, [ CHAMPION.KARNAK, CHAMPION.BLACKBOLT ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.HAWKEYE ], EFFECT.SHIELD_AGENTS),
        ...fromStars(4, 5, [ CHAMPION.BLACKWIDOW ], EFFECT.SHIELD_CLEARANCE),
    ]),

    ...fromId(CHAMPION.REDGOBLIN, [
        ...fromStars(4, 6, [ CHAMPION.VENOM ], EFFECT.FAMILY_FEUD),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANBLACK ], EFFECT.HATRED),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.IRONPATRIOT ], EFFECT.OSBORN_TO_BE_WILD),
        ...fromStars(4, 6, [ CHAMPION.CARNAGE, CHAMPION.GREENGOBLIN ], EFFECT.SELF_CENTERED),
        ...fromStars(3, 6, [ CHAMPION.CARNAGE, CHAMPION.SYMBIOTESUPREME, CHAMPION.VENOMDUCK ], EFFECT.SYMBIOTE_CONSCIOUSNESS),
    ]),

    ...fromId(CHAMPION.REDGUARDIAN, [
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOWDEADLY ], EFFECT.FAMILY_REUNION),
        ...fromStars(4, 6, [ CHAMPION.RHINO, CHAMPION.ABOMINATION ], EFFECT.EASTERN_BLOCKERS),
        ...fromStars(5, 6, [ CHAMPION.COLOSSUS, CHAMPION.UNSTOPPABLECOLOSSUS ], EFFECT.LIVING_STEEL_CURTAIN),
        ...fromStars(4, 6, [ CHAMPION.SABRETOOTH ], EFFECT.MAGNIFICENT_MANES),
        ...fromStars(4, 6, [ CHAMPION.OMEGARED ], EFFECT.ENHANCED_WITH_CARBONADIUM),
    ]),

    ...fromId(CHAMPION.REDHULK, [
        ...fromStars(3, 6, [ CHAMPION.ABOMINATION ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.HULK ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.ELEKTRA, CHAMPION.AGENTVENOM ], EFFECT.THUNDERBOLTS),
        ...fromStars(4, 6, [ CHAMPION.X23 ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.REDSKULL, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ETERNAL_ADVERSARIES),
        ...fromStars(3, 6, [ CHAMPION.PUNISHER2099 ], EFFECT.HAIL_HYDRA),
        ...fromStars(2, 6, [ CHAMPION.IRONPATRIOT, CHAMPION.KINGPIN, CHAMPION.LOKI, CHAMPION.MODOK ], EFFECT.DARK_ILLUMINATI),
    ]),

    ...fromId(CHAMPION.RHINO, [
        ...fromStars(2, 6, [ CHAMPION.ABOMINATION ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERGWEN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.ELECTRO ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.PUNISHER ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.ROCKET, [
        ...fromStars(2, 6, [ CHAMPION.STARLORD, CHAMPION.GROOT ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.GAMORA ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.RONAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.DRAX ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.ROGUE, [
        ...fromStars(3, 6, [ CHAMPION.NIGHTCRAWLER ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.GAMBIT ], EFFECT.POWER_GAIN),
        ...fromStars(2, 6, [ CHAMPION.MSMARVEL ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.DEADPOOL ], EFFECT.MUTANT_AGENDA),
    ]),

    ...fromId(CHAMPION.RONAN, [
        ...fromStars(2, 5, [ CHAMPION.BLACKBOLT ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.IRONMAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 5, [ CHAMPION.GAMORA ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 5, [ CHAMPION.HULK ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.RONIN, [
        ...fromStars(4, 6, [ CHAMPION.CAPTAINMARVELMOVIE ], EFFECT.LAST_HOPE),
        ...fromStars(4, 6, [ CHAMPION.ANTMAN ], EFFECT.UNLIKELY_COMBINATION),
        ...fromStars(2, 6, [ CHAMPION.NIGHTCRAWLER, CHAMPION.GUILLOTINE ], EFFECT.LIVE_AND_DIE_BY_THE_SWORD),
        ...fromStars(3, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.MASTERLESS),
        ...fromStars(2, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.SABRETOOTH, [
        ...fromStars(4, 6, [ CHAMPION.WOLVERINEOLDMAN ], EFFECT.UNTAMED_FORCE),
        ...fromStars(4, 6, [ CHAMPION.SCARLETWITCH, CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.DECIMATION),
        ...fromStars(3, 6, [ CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.KILLMONGER ], EFFECT.NO_MERCY),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.SASQUATCH, [
        ...fromStars(4, 6, [ CHAMPION.MANTHING, CHAMPION.SABRETOOTH ], EFFECT.JUST_HAIR_AND_THINGS),
        ...fromStars(3, 6, [ CHAMPION.HULK ], EFFECT.GAMMA_RAY_RAY),
        ...fromStars(4, 6, [ CHAMPION.SQUIRRELGIRL ], EFFECT.FURRY_BUDS),
        ...fromStars(5, 6, [ CHAMPION.THING, CHAMPION.GROOTKING, CHAMPION.SENTINEL ], EFFECT.GIANT_CHALLENGERS),
        ...fromStars(3, 6, [ CHAMPION.HULKBUSTER ], EFFECT.COMMON_HISTORY),
    ]),

    ...fromId(CHAMPION.SCARLETWITCH, [
        ...fromStars(2, 5, [ CHAMPION.CAPTAINMARVEL, CHAMPION.MSMARVEL ], EFFECT.ARMOR),
        ...fromStars(3, 5, [ CHAMPION.VISION ], EFFECT.POWER_GAIN),
        ...fromStars(3, 5, [ CHAMPION.ANTMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 5, [ CHAMPION.PHOENIX ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.SCARLETWITCHSIGIL, [
        ...fromStars(4, 6, [ CHAMPION.WOLVERINE, CHAMPION.STORM, CHAMPION.CYCLOPS, CHAMPION.EMMAFROST ], EFFECT.DECIMATION_SW),
        ...fromStars(4, 6, [ CHAMPION.SCARLETWITCH ], EFFECT.CHAOS_RISING),
        ...fromStars(4, 6, [ CHAMPION.VISION, CHAMPION.THEVISION ], EFFECT.TILL_INFINITY_DO_US_PART),
        ...fromStars(4, 6, [ CHAMPION.MEPHISTO, CHAMPION.DORMAMMU ], EFFECT.DEMONIC_PACT),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.DRSTRANGE, CHAMPION.HAWKEYE, CHAMPION.BLACKWIDOW ], EFFECT.HEALTH),
        ...fromStars(4, 6, [ CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.SENTINEL, [
        ...fromStars(3, 6, [ CHAMPION.ICEMAN, CHAMPION.CABLE, CHAMPION.NIGHTCRAWLER ], EFFECT.MUTANT_PURSUIT),
        ...fromStars(3, 6, [ CHAMPION.KINGPIN, CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.KILLMONGER ], EFFECT.SKILL_TRAINING),
        ...fromStars(3, 6, [ CHAMPION.VOID, CHAMPION.ANTMAN, CHAMPION.ELECTRO ], EFFECT.SCIENCE_RESEARCH),
        ...fromStars(3, 6, [ CHAMPION.KARLMORDO, CHAMPION.HOOD, CHAMPION.MORNINGSTAR ], EFFECT.MYSTIC_OBSERVATION),
        ...fromStars(3, 6, [ CHAMPION.ULTRON, CHAMPION.GREENGOBLIN, CHAMPION.YONDU ], EFFECT.TECH_ADVANCEMENT),
    ]),

    ...fromId(CHAMPION.SENTRY, [
        ...fromStars(4, 6, [ CHAMPION.VOID ], EFFECT.OTHER_HALF),
        ...fromStars(2, 6, [ CHAMPION.BLACKWIDOW, CHAMPION.VISION, CHAMPION.HAWKEYE, CHAMPION.CAPTAINAMERICA ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.HULK ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.SHANGCHI, [
        ...fromStars(2, 6, [ CHAMPION.ELEKTRA ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.BLACKWIDOW, CHAMPION.BEAST, CHAMPION.ANTMAN ], EFFECT.EYES_OF_THE_DRAGON),
        ...fromStars(2, 6, [ CHAMPION.LUKECAGE, CHAMPION.SHEHULK ], EFFECT.HEROES_FOR_HIRE),
        ...fromStars(4, 6, [ CHAMPION.IRONFIST, CHAMPION.IRONFISTWHITE ], EFFECT.MASTER_MARTIAL_ARTISTS),
        ...fromStars(5, 6, [ CHAMPION.MISTERNEGATIVE ], EFFECT.SHADOWLAND),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN ], EFFECT.THE_WAY_OF_THE_SPIDER),
    ]),

    ...fromId(CHAMPION.SHEHULK, [
        ...fromStars(2, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX ], EFFECT.LEGAL_DEFENSE),
        ...fromStars(4, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK, CHAMPION.REDHULK ], EFFECT.AGENTS_OF_SMASH),
        ...fromStars(3, 6, [ CHAMPION.SUPERIORIRONMAN, CHAMPION.LUKECAGE ], EFFECT.POWER_GAIN),
        ...fromStars(4, 6, [ CHAMPION.KAMALAKHAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.MEPHISTO ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.SILVERCENTURION, [
        ...fromStars(4, 6, [ CHAMPION.STORMPYRAMIDX, CHAMPION.SORCERERSUPREME, CHAMPION.JABARIPANTHER ], EFFECT.CHAMPIONS_OF_BATTLEWORLD),
        ...fromStars(4, 6, [ CHAMPION.IRONMANIW, CHAMPION.SUPERIORIRONMAN, CHAMPION.IRONMAN ], EFFECT.IRON_MEN),
        ...fromStars(4, 6, [ CHAMPION.THOR, CHAMPION.THORJANEFOSTER, CHAMPION.THORRAGNAROK ], EFFECT.ASGARDIAN_REPUBLIC),
        ...fromStars(5, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAIW, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.PATRIOT_GARRISON),
        ...fromStars(4, 6, [ CHAMPION.SQUIRRELGIRL, CHAMPION.MOLEMAN ], EFFECT.PET_PALS),
        ...fromStars(2, 6, [ CHAMPION.WARMACHINE ], EFFECT.HEALTH),
        ...fromStars(2, 3, [ CHAMPION.HULKBUSTER, CHAMPION.CIVILWARRIOR ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.SILVERSURFER, [
        ...fromStars(4, 6, [ CHAMPION.TERRAX, CHAMPION.AIRWALKER, CHAMPION.COSMICGHOSTRIDER ], EFFECT.HERALDS_OF_GALACTUS),
        ...fromStars(3, 6, [ CHAMPION.DRSTRANGE, CHAMPION.HULK ], EFFECT.SECRET_DEFENDERS),
        ...fromStars(4, 6, [ CHAMPION.MYSTERIO, CHAMPION.NIGHTTHRASHER ], EFFECT.MINE_TRAVELS_THROUGH_SPACE),
        ...fromStars(2, 6, [ CHAMPION.MRFANTASTIC, CHAMPION.INVISIBLEWOMAN, CHAMPION.HUMANTORCH, CHAMPION.THING ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.MEPHISTO, CHAMPION.DRDOOM, CHAMPION.ANNIHILUS ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.SORCERERSUPREME, [
        ...fromStars(3, 6, [ CHAMPION.STORMPYRAMIDX, CHAMPION.JABARIPANTHER, CHAMPION.SILVERCENTURION ], EFFECT.CHAMPIONS_OF_BATTLEWORLD),
        ...fromStars(5, 6, [ CHAMPION.DRSTRANGE, CHAMPION.SYMBIOTESUPREME ], EFFECT.DOCTORS_STRANGE),
        ...fromStars(4, 6, [ CHAMPION.DORMAMMU, CHAMPION.DRVOODOO, CHAMPION.KARLMORDO ], EFFECT.MYSTIC_ARTS),
        ...fromStars(2, 6, [ CHAMPION.ARCHANGEL, CHAMPION.NEBULA, CHAMPION.THECHAMPION ], EFFECT.BLUETIFUL_PEOPLE),
        ...fromStars(4, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK, CHAMPION.REDHULK, CHAMPION.JOEFIXIT, CHAMPION.SHEHULK ], EFFECT.GAMMA_HORDE),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN, CHAMPION.IRONMANIW, CHAMPION.WARMACHINE, CHAMPION.HULKBUSTER ], EFFECT.HOUSE_OF_IRON),
    ]),

    ...fromId(CHAMPION.SPIDERGWEN, [
        ...fromStars(3, 6, [ CHAMPION.RHINO, CHAMPION.DAREDEVIL, CHAMPION.REDHULK, CHAMPION.THANOS, CHAMPION.ULTRONCLASSIC ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN ], EFFECT.POWER_GAIN),
        ...fromStars(4, 6, [ CHAMPION.PUNISHER ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.VENOM, CHAMPION.CARNAGE, CHAMPION.VENOMDUCK, CHAMPION.SYMBIOTESUPREME ], EFFECT.GWENOM_RISING),
    ]),

    ...fromId(CHAMPION.SPIDERMAN, [
        ...fromStars(1, 6, [ CHAMPION.WOLVERINE ], EFFECT.HEALTH),
        ...fromStars(1, 6, [ CHAMPION.HAWKEYE ], EFFECT.ATTACK),
        ...fromStars(3, 6, [ CHAMPION.ELECTRO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.ARMOR),
        ...fromStars(1, 1, [ CHAMPION.IRONMAN ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.SPIDERHAM, [
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANMORALES ], EFFECT.TWO_DAYS_THIRTY_YEARS),
        ...fromStars(4, 6, [ CHAMPION.MOJO ], EFFECT.SATURDAY_MORNING_CARTOONS),
        ...fromStars(4, 6, [ CHAMPION.SPIDERGWEN ], EFFECT.SWINESTER_SIX_MOST_WANTED),
        ...fromStars(3, 6, [ CHAMPION.GWENPOOL, CHAMPION.PLATINUMPOOL, CHAMPION.GOLDPOOL, CHAMPION.SQUIRRELGIRL ], EFFECT.FOURTH_WALL_CRAWLER),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.SPIDERMANMORALES, [
        ...fromStars(2, 6, [ CHAMPION.VENOM, CHAMPION.DRDOOM ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.SPIDERGWEN, CHAMPION.KAMALAKHAN, CHAMPION.BLACKWIDOW, CHAMPION.HERCULES ], EFFECT.PERFECT_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.ELECTRO, CHAMPION.IRONPATRIOT, CHAMPION.GREENGOBLIN ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN ], EFFECT.IDOL),
        ...fromStars(3, 6, [ CHAMPION.SPIDERHAM, CHAMPION.SPIDERMAN2099, CHAMPION.SPIDERMANBLACK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.SPIDERVERSE_MENTORS),
        ...fromStars(4, 6, [ CHAMPION.MISTERNEGATIVE, CHAMPION.MYSTERIO, CHAMPION.REDGOBLIN, CHAMPION.VULTURE ], EFFECT.SPIDERSENSES_TINGLING),
    ]),

    ...fromId(CHAMPION.SPIDERMANSTARK, [
        ...fromStars(3, 5, [ CHAMPION.VULTURE ], EFFECT.AVENGERS_TRYOUT),
        ...fromStars(4, 5, [ CHAMPION.SPIDERMANMORALES, CHAMPION.KAMALAKHAN ], EFFECT.CONTEST_NOOBS),
        ...fromStars(2, 5, [ CHAMPION.IRONMAN, CHAMPION.HULKBUSTER ], EFFECT.KNOWLEDGE_SHARE),
    ]),

    ...fromId(CHAMPION.SPIDERMANSTEALTH, [
        ...fromStars(4, 6, [ CHAMPION.IRONMANIW ], EFFECT.STARK_INTERNSHIP),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMANBLACK, CHAMPION.SPIDERMANMORALES ], EFFECT.SPIDERMEN_IN_BLACK),
        ...fromStars(2, 6, [ CHAMPION.VULTURE ], EFFECT.BAD_FOR_BUSINESS),
        ...fromStars(5, 6, [ CHAMPION.ELECTRO ], EFFECT.CULTURE_SHOCK),
    ]),

    ...fromId(CHAMPION.SPIDERMANBLACK, [
        ...fromStars(2, 6, [ CHAMPION.STORM ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.ELECTRO ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.AGENTVENOM ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.SPIDERMAN2099, [
        ...fromStars(4, 6, [ CHAMPION.SPIDERMANSTARK, CHAMPION.SCARLETWITCH, CHAMPION.IRONMAN ], EFFECT.AI_ENTHUSIASTS),
        ...fromStars(5, 6, [ CHAMPION.SABRETOOTH, CHAMPION.LONGSHOT, CHAMPION.PSYLOCKEXFORCE ], EFFECT.COWORKERS),
        ...fromStars(2, 6, [ CHAMPION.DRDOOM, CHAMPION.PUNISHER2099, CHAMPION.DROCTOPUS ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANMORALES, CHAMPION.SPIDERHAM, CHAMPION.SPIDERGWEN ], EFFECT.SPIDERVERSE_VETERANS),
        ...fromStars(5, 6, [ CHAMPION.VENOM, CHAMPION.CARNAGE ], EFFECT.SYMBIOTE_PROBLEMS),
    ]),

    ...fromId(CHAMPION.SQUIRRELGIRL, [
        ...fromStars(2, 6, [ CHAMPION.LUKECAGE ], EFFECT.SUPERNANNY),
        ...fromStars(2, 6, [ CHAMPION.DEADPOOL ], EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS),
        ...fromStars(3, 6, [ CHAMPION.SENTINEL ], EFFECT.HARDWIRED_FOR_HEARTBREAK),
        ...fromStars(5, 6, [ CHAMPION.DRDOOM, CHAMPION.MODOK, CHAMPION.KARLMORDO, CHAMPION.THANOS ], EFFECT.BEAT_UP_THE_UNIVERSE),
    ]),

    ...fromId(CHAMPION.STARLORD, [
        ...fromStars(2, 6, [ CHAMPION.ROCKET, CHAMPION.GROOT ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.DRAX ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.GAMORA ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.STORM, [
        ...fromStars(2, 6, [ CHAMPION.BLACKPANTHER ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.MAGIK ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.STORMPYRAMIDX, [
        ...fromStars(4, 6, [ CHAMPION.BISHOP ], EFFECT.SETUP_AND_SPIKE),
        ...fromStars(4, 6, [ CHAMPION.STORM ], EFFECT.UNDER_THE_WEATHER),
        ...fromStars(3, 6, [ CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.KILLMONGER ], EFFECT.KINGDOM_OF_WAKANDA),
        ...fromStars(3, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANMORALES, CHAMPION.SPIDERGWEN ], EFFECT.SPIDERGUILD),
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.COLOSSUS, CHAMPION.BISHOP ], EFFECT.MUTANT_AGENDA),
        ...fromStars(4, 6, [ CHAMPION.SORCERERSUPREME, CHAMPION.JABARIPANTHER, CHAMPION.SILVERCENTURION ], EFFECT.CHAMPIONS_OF_BATTLEWORLD),
    ]),

    ...fromId(CHAMPION.STRYFE, [
        ...fromStars(5, 6, [ CHAMPION.APOCALYPSE ], EFFECT.BIG_BAD_DAD),
        ...fromStars(4, 6, [ CHAMPION.GUILLOTINE, CHAMPION.THOR, CHAMPION.HOOD ], EFFECT.BULL_TARGETS),
        ...fromStars(5, 6, [ CHAMPION.CABLE ], EFFECT.CLONED_AT_BIRTH),
        ...fromStars(2, 6, [ CHAMPION.HAVOK, CHAMPION.MISTERSINISTER, CHAMPION.BEAST ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.PHOENIX, CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S, CHAMPION.CABLE ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.EBONYMAW ], EFFECT.MISS_ME),
    ]),

    ...fromId(CHAMPION.SUPERSKRULL, [
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.MRFANTASTIC ], EFFECT.FORCE_BLOCK),
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN ], EFFECT.HERBIE),
        ...fromStars(3, 6, [ CHAMPION.IRONFIST ], EFFECT.HOSTILE_TAKEOVER),
        ...fromStars(2, 6, [ CHAMPION.THING, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.RAIN_OF_FIRE),
        ...fromStars(2, 6, [ CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.THE_BRAVE_AND_THE_BOULDER),
        ...fromStars(3, 6, [ CHAMPION.DRDOOM ], EFFECT.WEDDING_CRASHER),
    ]),

    ...fromId(CHAMPION.SUNSPOT, [
        ...fromStars(4, 6, [ CHAMPION.CABLE, CHAMPION.WARLOCK ], EFFECT.NEW_MUTANTS),
        ...fromStars(5, 6, [ CHAMPION.REDHULK, CHAMPION.MODOK ], EFFECT.AIM_TECHNOLOGY),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.IRONMAN ], EFFECT.LEADING_AVENGERS),
        ...fromStars(3, 6, [ CHAMPION.MEPHISTO, CHAMPION.HELA ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.MAGIK, CHAMPION.BEAST, CHAMPION.COLOSSUS, CHAMPION.CYCLOPS ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.SUPERIORIRONMAN, [
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.DAREDEVIL ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.THOR ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.SYMBIOTESUPREME, [
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.KARLMORDO ], EFFECT.MYSTIC_MASTERS),
        ...fromStars(3, 6, [ CHAMPION.DORMAMMU, CHAMPION.MEPHISTO ], EFFECT.ANCIENT_HUNGER),
        ...fromStars(4, 6, [ CHAMPION.VENOMDUCK, CHAMPION.VENOM, CHAMPION.CARNAGE, CHAMPION.VENOMPOOL, CHAMPION.SPIDERMANBLACK, CHAMPION.AGENTVENOM ], EFFECT.SUPREME_SYMBIOSIS),
    ]),

    ...fromId(CHAMPION.TASKMASTER, [
        ...fromStars(3, 6, [ CHAMPION.MOONKNIGHT ], EFFECT.TERMINATION_CONTRACT),
        ...fromStars(2, 6, [ CHAMPION.CROSSBONES ], EFFECT.PROFESSORS_IN_CRIME),
        ...fromStars(4, 6, [ CHAMPION.HAWKEYE ], EFFECT.MOSTLY_AVERAGE_JOES),
        ...fromStars(4, 6, [ CHAMPION.WINTERSOLDIER ], EFFECT.THUNDER),
    ]),

    ...fromId(CHAMPION.TERRAX, [
        ...fromStars(3, 6, [ CHAMPION.PHOENIX ], EFFECT.DEATH_AND_RESURRECTION),
        ...fromStars(5, 6, [ CHAMPION.REDHULK, CHAMPION.KARLMORDO ], EFFECT.ELDERS_GAME),
        ...fromStars(2, 6, [ CHAMPION.ANNIHILUS ], EFFECT.PRISONER),
        ...fromStars(4, 6, [ CHAMPION.SILVERSURFER, CHAMPION.AIRWALKER, CHAMPION.COSMICGHOSTRIDER ], EFFECT.HERALDS_OF_GALACTUS),
    ]),

    ...fromId(CHAMPION.THANOS, [
        ...fromStars(4, 6, [ CHAMPION.STARLORD, CHAMPION.HULK ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.DEADPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.GAMORA ], EFFECT.HEALTH),
    ]),

    ...fromId(CHAMPION.THECHAMPION, [
        ...fromStars(3, 6, [ CHAMPION.LUKECAGE ], EFFECT.TOUGH_BRAWLERS),
        ...fromStars(2, 6, [ CHAMPION.MEPHISTO, CHAMPION.SENTRY ], EFFECT.PERSISTENT_FORCE),
        ...fromStars(4, 6, [ CHAMPION.THORRAGNAROK ], EFFECT.COMBO_FIGHTER),
        ...fromStars(2, 6, [ CHAMPION.AEGON ], EFFECT.DAVID_AND_GOLIATH),
        ...fromStars(2, 6, [ CHAMPION.MEPHISTO, CHAMPION.DRAX ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.HOOD, [
        ...fromStars(2, 6, [ CHAMPION.DRVOODOO, CHAMPION.PUNISHER, CHAMPION.TIGRA, CHAMPION.DRSTRANGE ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.IRONPATRIOT, CHAMPION.LOKI, CHAMPION.TERRAX, CHAMPION.TASKMASTER ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.DORMAMMU ], EFFECT.DARK_EMPOWERMENT),
        ...fromStars(3, 6, [ CHAMPION.JOEFIXIT, CHAMPION.KINGPIN ], EFFECT.CRIME_BOSSES),
        ...fromStars(4, 6, [ CHAMPION.ABOMINATION, CHAMPION.GROOTKING, CHAMPION.RONAN, CHAMPION.VULTURE ], EFFECT.BUT_THE_BEST_VILLAIN),
        ...fromStars(4, 6, [ CHAMPION.MODOK, CHAMPION.MOLEMAN, CHAMPION.MYSTERIO, CHAMPION.MOJO ], EFFECT.NOT_THE_HERO),
    ]),

    ...fromId(CHAMPION.THEOVERSEER, [
        ...fromStars(6, 6, [ CHAMPION.TERRAX, CHAMPION.AIRWALKER ], EFFECT.COSMIC_CONTROL),
        ...fromStars(4, 6, [ CHAMPION.REDSKULL, CHAMPION.THANOS ], EFFECT.CUBE_WIELDERS),
        ...fromStars(2, 6, [ CHAMPION.DRDOOM ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 6, [ CHAMPION.HULK, CHAMPION.HULKIMMORTAL, CHAMPION.HULKRAGNAROK, CHAMPION.JOEFIXIT ], EFFECT.IDENTITY_DISORDER),
        ...fromStars(4, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAIW, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.SHIELD_BUDDIES),
        ...fromStars(5, 6, [ CHAMPION.SILVERSURFER ], EFFECT.SPACE_SURFERS),
    ]),

    ...fromId(CHAMPION.THING, [
        ...fromStars(3, 6, [ CHAMPION.KORG ], EFFECT.SCHOOL_OF_HARD_ROCKS),
        ...fromStars(4, 6, [ CHAMPION.THECHAMPION ], EFFECT.WORTHY_OPPONENT),
        ...fromStars(2, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.HUMANTORCH, CHAMPION.INVISIBLEWOMAN, CHAMPION.MRFANTASTIC ], EFFECT.THE_BRAVE_AND_THE_BOULDER),
        ...fromStars(3, 6, [ CHAMPION.HUMANTORCH ], EFFECT.PASSIVE_AGGRESSIVE),
    ]),

    ...fromId(CHAMPION.THOR, [
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.IRONMAN ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.JUGGERNAUT ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.THORJANEFOSTER, [
        ...fromStars(2, 6, [ CHAMPION.THOR ], EFFECT.POWER_GAIN),
        ...fromStars(3, 6, [ CHAMPION.VISION ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.BLACKWIDOW ], EFFECT.ARMOR),
        ...fromStars(4, 6, [ CHAMPION.JOEFIXIT ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.THORRAGNAROK, [
        ...fromStars(3, 6, [ CHAMPION.LOKI ], EFFECT.LIKE_OLD_DAYS),
        ...fromStars(4, 6, [ CHAMPION.HELA ], EFFECT.NOT_AFRAID_OF_DEATH),
        ...fromStars(4, 6, [ CHAMPION.HULK, CHAMPION.HULKRAGNAROK ], EFFECT.FRIEND_FROM_WORK),
        ...fromStars(2, 2, [ CHAMPION.HULK ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.TIGRA, [
        ...fromStars(6, 6, [ CHAMPION.HAWKEYE, CHAMPION.WARMACHINE ], EFFECT.WEST_COAST_AVENGERS),
        ...fromStars(4, 6, [ CHAMPION.BLACKPANTHER, CHAMPION.BLACKPANTHERCIVILWAR ], EFFECT.FELINE_POSSESSION),
        ...fromStars(2, 6, [ CHAMPION.VULTURE, CHAMPION.HOWARDTHEDUCK ], EFFECT.ENTREE),
        ...fromStars(3, 6, [ CHAMPION.ELSABLOODSTONE ], EFFECT.BIG_GAME_HUNTERS),
        ...fromStars(2, 6, [ CHAMPION.LUKECAGE, CHAMPION.IRONMAN, CHAMPION.MOONKNIGHT ], EFFECT.POWER_GAIN),
    ]),

    ...fromId(CHAMPION.ULTRON, [
        ...fromStars(2, 6, [ CHAMPION.BLACKWIDOW, CHAMPION.BLACKWIDOWDEADLY, CHAMPION.THORRAGNAROK, CHAMPION.SCARLETWITCH ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN, CHAMPION.SUPERIORIRONMAN, CHAMPION.IRONMANIW ], EFFECT.HEALTH),
        ...fromStars(4, 6, [ CHAMPION.VISION, CHAMPION.THEVISION, CHAMPION.THORRAGNAROK, CHAMPION.HULKBUSTER ], EFFECT.MY_BEAUTIFUL_METEOR),
        ...fromStars(4, 6, [ CHAMPION.ULTRONCLASSIC, CHAMPION.GUILLOTINE2099, CHAMPION.SENTINEL, CHAMPION.DRAGONMAN ], EFFECT.MY_WORLD_OF_METAL),
    ]),

    ...fromId(CHAMPION.ULTRONCLASSIC, [
        ...fromStars(5, 5, [ CHAMPION.VISION, CHAMPION.THEVISION ], EFFECT.CRITICAL_RATE),
        ...fromStars(5, 5, [ CHAMPION.THOR ], EFFECT.ATTACK),
        ...fromStars(5, 5, [ CHAMPION.THANOS, CHAMPION.KANG ], EFFECT.CRITICAL_DAMAGE),
    ]),

    ...fromId(CHAMPION.UNSTOPPABLECOLOSSUS, [
        ...fromStars(2, 5, [ CHAMPION.MAGIK ], EFFECT.HEALTH),
        ...fromStars(2, 5, [ CHAMPION.JUGGERNAUT ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.WOLVERINE, CHAMPION.WOLVERINEOLDMAN ], EFFECT.ARMOR),
        ...fromStars(3, 5, [ CHAMPION.CYCLOPS ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.VENOM, [
        ...fromStars(2, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERMANMORALES ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMANBLACK, CHAMPION.AGENTVENOM, CHAMPION.VENOMPOOL ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.ELECTRO, CHAMPION.DROCTOPUS ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(4, 6, [ CHAMPION.JOEFIXIT ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.VULTURE, CHAMPION.GREENGOBLIN ], EFFECT.ARACHNID_HUNTERS),
        ...fromStars(4, 6, [ CHAMPION.SHEHULK, CHAMPION.CARNAGE ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.VENOMDUCK, [
        ...fromStars(2, 6, [ CHAMPION.CARNAGE, CHAMPION.VENOMPOOL ], EFFECT.GENETIC_RECODE_AGGRESSION),
        ...fromStars(2, 6, [ CHAMPION.AGENTVENOM, CHAMPION.SPIDERMANBLACK ], EFFECT.GENETIC_RECODE_SURVIVAL),
        ...fromStars(2, 6, [ CHAMPION.DOMINO ], EFFECT.GENETIC_RECODE_PROBABILITY),
        ...fromStars(2, 6, [ CHAMPION.GROOT ], EFFECT.GENETIC_RECODE_REGENESIS),
        ...fromStars(3, 6, [ CHAMPION.VENOM ], EFFECT.GENETIC_RECODE_HIVE_MIND),
        ...fromStars(3, 6, [ CHAMPION.BLADE ], EFFECT.GENETIC_RECODE_BLOODLETTING),
        ...fromStars(4, 6, [ CHAMPION.HOWARDTHEDUCK ], EFFECT.GENETIC_RECODE_EVOLUTION),
        ...fromStars(4, 6, [ CHAMPION.SYMBIOTESUPREME ], EFFECT.GENETIC_RECODE_BARRIER),
    ]),

    ...fromId(CHAMPION.VENOMPOOL, [
        ...fromStars(2, 6, [ CHAMPION.DEADPOOL, CHAMPION.GOLDPOOL, CHAMPION.PLATINUMPOOL, CHAMPION.DEADPOOLXFORCE ], EFFECT.START_WITH_FRESH_DEADPOOL),
        ...fromStars(2, 6, [ CHAMPION.DAREDEVIL, CHAMPION.DAREDEVILNETFLIX, CHAMPION.FALCON, CHAMPION.SPIDERMANSTEALTH ], EFFECT.ACCURATELY_MEASURE_INGREDIENTS),
        ...fromStars(2, 6, [ CHAMPION.VENOM, CHAMPION.AGENTVENOM, CHAMPION.VENOMDUCK, CHAMPION.SYMBIOTESUPREME ], EFFECT.BLEND_IN_SYMBIOTE),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAIW, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ADD_PLAIN_WHITE_FLOUR),
        ...fromStars(2, 6, [ CHAMPION.REDHULK, CHAMPION.SUNSPOT, CHAMPION.HUMANTORCH ], EFFECT.FRY_IN_SKILLET),
        ...fromStars(2, 6, [ CHAMPION.BISHOP, CHAMPION.CABLE, CHAMPION.KANG ], EFFECT.ADJUST_COOKING_TIMER),
        ...fromStars(2, 6, [ CHAMPION.VISIONAARKUS, CHAMPION.ICEMAN ], EFFECT.ALLOW_TO_COOL),
        ...fromStars(2, 6, [ CHAMPION.RONAN, CHAMPION.HULK, CHAMPION.HULKIMMORTAL, CHAMPION.THORJANEFOSTER ], EFFECT.MUNCH_STUNNING_FOOD),
    ]),

    ...fromId(CHAMPION.VISION, [
        ...fromStars(2, 6, [ CHAMPION.SCARLETWITCH ], EFFECT.POWER_GAIN),
        ...fromStars(2, 6, [ CHAMPION.IRONMAN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.THEVISION, [
        ...fromStars(2, 5, [ CHAMPION.IRONMAN ], EFFECT.HEALTH),
        ...fromStars(2, 5, [ CHAMPION.SCARLETWITCH ], EFFECT.CRITICAL_RATE),
        ...fromStars(3, 5, [ CHAMPION.ULTRON ], EFFECT.ATTACK),
    ]),

    ...fromId(CHAMPION.VISIONAARKUS, [
        ...fromStars(5, 6, [ CHAMPION.VISION, CHAMPION.THEVISION ], EFFECT.FIRST_OF_HIS_NAME),
        ...fromStars(4, 6, [ CHAMPION.ICEMAN, CHAMPION.MYSTERIO ], EFFECT.DRY_ICE),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOWCLAIRE, CHAMPION.WOLVERINEOLDMAN, CHAMPION.CAPTAINAMERICA ], EFFECT.SENIORS_DISCOUNT),
        ...fromStars(2, 6, [ CHAMPION.DRSTRANGE, CHAMPION.CAPTAINAMERICAWWII, CHAMPION.WINTERSOLDIER, CHAMPION.NAMOR ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.VOID, [
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW, CHAMPION.HAWKEYE, CHAMPION.CAPTAINAMERICA, CHAMPION.VISION ], EFFECT.OVERCOMING_FEAR),
        ...fromStars(2, 6, [ CHAMPION.THOR, CHAMPION.DRSTRANGE ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.HULK ], EFFECT.GRIPPED_BY_FEAR),
        ...fromStars(4, 6, [ CHAMPION.SENTRY ], EFFECT.ENGULFED_BY_THE_VOID),
    ]),

    ...fromId(CHAMPION.VULTURE, [
        ...fromStars(3, 6, [ CHAMPION.ELECTRO, CHAMPION.DROCTOPUS, CHAMPION.RHINO ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.SPIDERMAN, CHAMPION.SPIDERGWEN, CHAMPION.SPIDERMANMORALES ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.ATTACK),
        ...fromStars(4, 6, [ CHAMPION.VENOM, CHAMPION.MYSTERIO, CHAMPION.GREENGOBLIN ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.KINGPIN, CHAMPION.YELLOWJACKET, CHAMPION.MASACRE ], EFFECT.BATTLEREALMS_CHANGING),
        ...fromStars(4, 6, [ CHAMPION.WARMACHINE, CHAMPION.ULTRON, CHAMPION.SENTRY ], EFFECT.TIME_WE_CHANGED_TOO),
    ]),

    ...fromId(CHAMPION.WARMACHINE, [
        ...fromStars(4, 6, [ CHAMPION.ANTMAN, CHAMPION.WINTERSOLDIER, CHAMPION.CAPTAINAMERICA ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.HAWKEYE, CHAMPION.CAPTAINAMERICAIW, CHAMPION.FALCON ], EFFECT.CRITICAL_RATE),
        ...fromStars(2, 6, [ CHAMPION.HULKBUSTER, CHAMPION.GUARDIAN, CHAMPION.CIVILWARRIOR ], EFFECT.FORTIFY_ENHANCEMENT),
        ...fromStars(3, 6, [ CHAMPION.IRONMAN, CHAMPION.SUPERIORIRONMAN, CHAMPION.HULKBUSTER, CHAMPION.IRONMANIW ], EFFECT.ARMOR),
        ...fromStars(3, 6, [ CHAMPION.HAWKEYE, CHAMPION.NIGHTTHRASHER, CHAMPION.WINTERSOLDIER, CHAMPION.BLACKWIDOWDEADLY ], EFFECT.SKIRMISH_ENHANCEMENT),
        ...fromStars(3, 6, [ CHAMPION.SILVERSURFER, CHAMPION.GAMORA, CHAMPION.HEIMDALL ], EFFECT.SUPPORT_ENHANCEMENT),
        ...fromStars(3, 6, [ CHAMPION.BLACKWIDOW, CHAMPION.THEVISION, CHAMPION.BLACKPANTHERCIVILWAR, CHAMPION.VISION, CHAMPION.SPIDERMANSTARK, CHAMPION.SPIDERMANSTEALTH ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.WARLOCK, [
        ...fromStars(2, 6, [ CHAMPION.MAGIK, CHAMPION.SUNSPOT ], EFFECT.SELFFRIENDS),
        ...fromStars(4, 6, [ CHAMPION.ULTRONCLASSIC, CHAMPION.ULTRON, CHAMPION.VISION, CHAMPION.THEVISION ], EFFECT.ROBOT_UPRISING),
        ...fromStars(3, 6, [ CHAMPION.CABLE ], EFFECT.GOING_VIRAL),
        ...fromStars(2, 6, [ CHAMPION.DOMINO, CHAMPION.MAGNETO, CHAMPION.MAGNETOMARVELNOW ], EFFECT.MUTANT_AGENDA),
    ]),

    ...fromId(CHAMPION.WASP, [
        ...fromStars(3, 6, [ CHAMPION.ANTMAN, CHAMPION.GHOST ], EFFECT.HARD_TO_HIT),
        ...fromStars(4, 6, [ CHAMPION.YELLOWJACKET ], EFFECT.DEADLY_STING),
        ...fromStars(4, 6, [ CHAMPION.IRONMANIW, CHAMPION.IRONMAN ], EFFECT.ADVANCED_TECH),
        ...fromStars(3, 6, [ CHAMPION.ANTMAN ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.GHOST ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.WINTERSOLDIER, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.CAPTAINAMERICA ], EFFECT.PERFECT_BLOCK),
        ...fromStars(3, 6, [ CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ARMOR),
    ]),

    ...fromId(CHAMPION.WOLVERINE, [
        ...fromStars(2, 5, [ CHAMPION.CYCLOPS, CHAMPION.CYCLOPS90S ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(3, 5, [ CHAMPION.CAPTAINAMERICA, CHAMPION.CAPTAINAMERICAWWII ], EFFECT.ARMOR),
        ...fromStars(3, 5, [ CHAMPION.MAGNETO ], EFFECT.CRITICAL_RATE),
    ]),

    ...fromId(CHAMPION.WEAPONX, [
        ...fromStars(5, 6, [ CHAMPION.WOLVERINE, CHAMPION.WOLVERINEOLDMAN, CHAMPION.X23 ], EFFECT.A_GANG_OF),
        ...fromStars(5, 6, [ CHAMPION.SABRETOOTH ], EFFECT.LAB_PARTNERS),
        ...fromStars(5, 6, [ CHAMPION.GOLDPOOL, CHAMPION.THANOS, CHAMPION.KANG ], EFFECT.TROPHY_CASE),
    ]),

    ...fromId(CHAMPION.X23, [
        ...fromStars(2, 6, [ CHAMPION.WOLVERINE, CHAMPION.WOLVERINEOLDMAN ], EFFECT.HEALTH),
        ...fromStars(3, 6, [ CHAMPION.AGENTVENOM ], EFFECT.PERFECT_BLOCK),
        ...fromStars(4, 6, [ CHAMPION.REDHULK ], EFFECT.PERFECT_BLOCK),
    ]),

    ...fromId(CHAMPION.YELLOWJACKET, [
        ...fromStars(2, 6, [ CHAMPION.ANTMAN, CHAMPION.WASP ], EFFECT.ATTACK),
        ...fromStars(2, 6, [ CHAMPION.ULTRON, CHAMPION.LOKI, CHAMPION.KANG ], EFFECT.CRITICAL_DAMAGE),
        ...fromStars(2, 6, [ CHAMPION.SUPERIORIRONMAN, CHAMPION.HULKBUSTER, CHAMPION.IRONMAN, CHAMPION.IRONMANIW ], EFFECT.IDOL),
        ...fromStars(4, 6, [ CHAMPION.JOEFIXIT, CHAMPION.YONDU, CHAMPION.KINGPIN, CHAMPION.TASKMASTER ], EFFECT.POWER_OF_MONEY),
        ...fromStars(4, 6, [ CHAMPION.KILLMONGER, CHAMPION.MAGNETO, CHAMPION.MOLEMAN, CHAMPION.STORMPYRAMIDX ], EFFECT.REVOLUTIONS_NEED_ARMS),
    ]),

    ...fromId(CHAMPION.YONDU, [
        ...fromStars(4, 6, [ CHAMPION.RONAN ], EFFECT.CRITICAL_RATE),
        ...fromStars(4, 6, [ CHAMPION.ROCKET ], EFFECT.ARMOR),
        ...fromStars(2, 6, [ CHAMPION.BEAST, CHAMPION.NIGHTCRAWLER ], EFFECT.IT_AINT_EASY),
        ...fromStars(3, 6, [ CHAMPION.STARLORD ], EFFECT.CRITICAL_DAMAGE),
    ]),

].map((synergy) => new Synergy({
    ...synergy,
    effectAmount: effectAmount(synergy.effectId, synergy.fromStars),
}));

function effectAmount(effectId, fromStars) {
    const amounts = EFFECT_STARS_AMOUNT[ effectId ];
    if(!amounts) {
        return 0;
    }
    return amounts[ EFFECT_STARS_INDEX[ fromStars ] || 0 ] || 0;
}

function synergiesFromChampions(champions) {
    const groups = {};
    const validChampions = champions.filter((champion) => champion);
    return synergies.filter(({ attr: { fromId, fromStars, toId, group } }) => {
        const id = `${ fromId }-${ fromStars }`;
        const found = validChampions.find((champion) => champion.id === id) &&
            validChampions.find(({ attr: { uid } }) => uid === toId);
        if(!found) {
            return false;
        }
        if(group) {
            if(groups[ group ]) {
                return false;
            }
            groups[ group ] = true;
        }
        return true;
    });
}

export { synergiesFromChampions };
export default synergies;



// WEBPACK FOOTER //
// ./src/data/synergies.js